//////LIBRARY//////
import _, { cloneDeep, filter, find, get, isEmpty, isEqual, isNull, isNumber, isUndefined, map, reject, forEach, findIndex, hasIn } from 'lodash'
import React, { Fragment, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router'
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
//////COMPONENTS//////
import DropdownCheckbox from '../../components/DropdownCheckbox'
import Tooltip from '../../components/Tooltip/Tooltip'
import TooltipHelp from '../../components/TooltipHelp'
import Button from '../../components/Ui/Buttons'
import ImgButton from '../../components/Ui/ImgButton'
import ToggleFilters from '../../components/Ui/ToggleFilters'
import { divisionPicsConfig } from '../../constants/AssetsPicturesConfigList'
import { uriList } from '../../routings/settings/RouteList'
import { companiesManagerActionCreators } from '../../store/actions'
import {
	ControllerFileWrapper,
	ErrorInputMsg,
	InputLogin,
	InputWrapper,
	LabelFileCustom,
	LabelText,
	OptionCustom,
	PageTitle,
	PageWrapperActionReset,
	PageWrapperActions,
	PageWrapperActionValidate,
	PageWrapperGrids,
	PageWrapperLinks,
	PageWrapperSecondaryLinks,
	SearchReset,
	SelectInput,
	SelectInputCustom,
	SelectInputWrapper,
	TextModal,
	ButtonWrapper,
} from '../../theme/GlobalCss'
import Theme from '../../theme/theme'
import Modals from '../../components/Modals'
import StringFormatter from '../../helpers/StringFormatter'
//////ASSETS//////
import ArrowDownGrey from '../../assets/icones/global/arrow-down-big-grey.svg'
import ArrowDown from '../../assets/icones/global/arrow-down-big.svg'
import ArrowUpGrey from '../../assets/icones/global/arrow-up-big-grey.svg'
import ArrowUp from '../../assets/icones/global/arrow-up-big.svg'
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'

//////STYLED//////
const CompanyDetailWrapper = styled.div`
	position: relative;
`
const PageWrapperGridsCustom = styled(PageWrapperGrids)`
	grid-template-columns: 33% 66%;
`
const LineTableHeader = styled.div`
	display: grid;
	grid-template-columns: max-content repeat(auto-fit, max-content);
	grid-auto-flow: column;
	grid-column-gap: 16px;
	grid-template-rows: max-content;
	grid-auto-rows: 32px;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	box-sizing: border-box;
`
const PageTitleCustom = styled(PageTitle)`
	color: ${(props) => props.theme.text.colors.primary};
`
const CompanyDetailPart = styled.div``

const CompanyDetailOverflow = styled.div`
    overflow-y: auto;
    height: calc(100vh - 360px);
    display: grid;
    grid-row-gap: 20px;

    &::-webkit-scrollbar {
		width: 15px;
		background-color: rgba(0,0,0,.15);
		height:50px;
	}
	  &::-webkit-scrollbar-thumb {
		  background: #4D4F5C; 
	}
	  &::-webkit-scrollbar-thumb:active {
		background rgba(77, 79, 92, 0.7); 
	}
	  &::-webkit-scrollbar-button:vertical:decrement:single-button {
		  background: no-repeat url(${ArrowUp}) center;
		  height:15px;
	}
  
	  &::-webkit-scrollbar-button:vertical:increment:single-button {
		  background: no-repeat url(${ArrowDown}) center;
		  height:15px;
	}
	&::-webkit-scrollbar-button:vertical:decrement:single-button:active {
		background: no-repeat url(${ArrowUpGrey}) center;
		height:15px;
  }

	&::-webkit-scrollbar-button:vertical:increment:single-button:active {
		background: no-repeat url(${ArrowDownGrey}) center;
		height:15px;
  }
	  /* scrollbar styling standard version */
	  & {
		scrollbar-color: #4D4F5C #E5E5E5;
		scrollbar-width: thin;
	}
`
const CompanyManagerSubPart = styled.div`
	align-items: ${(props) => (props.class === 'va-top' ? 'start' : 'center')};
	display: grid;
	grid-template-columns: 240px auto;
	grid-column-gap: 20px;
	align-items: start;
	& > :first-child {
		text-align: left;
		line-height: 32px;
	}
	& > :last-child {
		margin-right: auto;
		display: flex;
		flex-direction: column;
	}
	& input[type='text'] {
		width: 212px;
	}
`
const PreviewFileWrapper = styled.div`
	margin-left: auto;
	& > img {
		width: 151px;
		height: 61px;
		border: 1px solid ${(props) => props.theme.colors.TabNav.border};
		margin-right: 10px;
	}
`
const PreviewFileHandler = styled.div`
	flex-direction: row !important;
`
const SearchResetCustom = styled(SearchReset)`
	margin: 0px 10px 0px 0px !important;
`
const CompanyManagerSubPartToggle = styled(CompanyManagerSubPart)`
	& > :last-child {
		flex-direction: row !important;
	}
`
const CompanyManagerSubPartSeparator = styled.div`
	margin: 0px;
	width: 468px;
	height: 1px;
	background-color: ${(props) => props.theme.colors.black};
`

const CompanyDivisions = styled.div`
	display: flex;
	flex-direction: row;
	& > :first-child {
		display: grid;
		grid-row-gap: 4px;
		width: 40%;
		overflow-y: auto;
		height: calc(100vh - 360px);
		grid-auto-rows: 45px;
		border-right: ${(props) => (props.visible ? `10px solid  ${props.theme.colors.primary}` : 'none')};
	}
	& > :last-child {
		width: 60%;
		overflow-y: auto;
		max-height: calc(100vh - 360px);
		border-right: 1px solid ${(props) => props.theme.colors.TabNav.border};
		border-top: 1px solid ${(props) => props.theme.colors.TabNav.border};
		border-bottom: 1px solid ${(props) => props.theme.colors.TabNav.border};
		box-sizing: border-box;
		display: ${(props) => (props.visible ? 'block' : 'none')};
	}
`
const CompanyDivisionPart = styled.div``

const CompanyDivisionFields = styled.div`
	& > div {
		display: ${(props) => (props.visible ? 'grid' : 'none')};
		grid-row-gap: 20px;
		grid-column-gap: 20px;
		grid-template-columns: max-content 216px;
		grid-auto-rows: min-content;
		padding: 20px 40px;
		margin-top: -1px;
		border-top: 1px solid ${(props) => props.theme.colors.TabNav.border};
		& > :nth-child(2n-1) {
			line-height: 32px;
		}
	}
`
const CompanyDiv = styled.div`
	padding: 0px 20px;
	border: 1px solid ${(props) => props.theme.colors.listNav.border};
	display: flex;
	flex-direction: row;
	& > input {
		margin: 0px 20px 0px 0px;
	}
	& > img {
		margin: 0px 6px 0px 0px;
		width: 16px;
		height: 16px;
	}
	align-items: center;
	background-color: ${(props) => (props.selected ? props.theme.colors.primary : 'transparent')};
	& > span {
		color: ${(props) => (props.selected ? props.theme.colors.white : props.theme.colors.menu.link)};
		font-weight: normal;
		font-size: ${(props) => props.theme.font.fs};
	}
	border: ${(props) => (props.selected ? 'none' : '')};
`
const DeviseSpan = styled.span`
	color: ${(props) => props.theme.colors.eraser};
	width: 212px;
`
const PartnerItem = styled.div`
	color: ${(props) => props.theme.colors.black}
	display: grid;
	grid-template-columns: auto auto;
	& > img {
		margin-right: 20px;
		max-width: 10px;
	}
	justify-content: start;
	padding: 10px 0px;
	align-items: center;
`
const LabelTextCustom = styled(LabelText)`
	font-weight: normal;
`
const DivisionTitle = styled(LabelText)`
	margin-bottom: 25px;
	width: 100%;
	font-size: ${(props) => props.theme.font.fm};
`
const DropdownCheckboxHandler = styled.div`
	& > div {
		font-size: ${(props) => props.theme.font.fs};
	}
`
const WrapperTextModal = styled.div`
	height: 150px;
	overflow-y: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	margin: 20px 0;
`

const ExportTypeItemWrapper = styled.div`
	display: grid !important;
	grid-template-columns: auto auto;
	grid-row-gap: 10px;
	grid-column-gap: 10px;
	align-items: center;
`

const ExportTypeItem = styled.div`
	display: grid;
	grid-template-columns: auto auto;
	& > input {
	}
	justify-content: start;
	grid-column-gap: 10px;
	align-items: center;
	line-height: 32px;
`

const ControllerWrapperCustom = styled.div`
	flex-direction: row;
`

const SMSRefillLink = styled.a`
	color: ${(props) => props.theme.colors.primary};
	text-decoration: underline;
	cursor: pointer;
`

const TextModalCustom = styled(TextModal)`
	display: flex;
	flex-direction: row;
	grid-column-gap: 20px;
	& > div {
		line-height: 32px;
	}
	& > div:first-child {
		font-weight: bold;
	}
`

//////STYLED//////

const CompanyDetail = (props) => {
	const { translations, companyDetail, kioskCreationDefinitionData, modalShow, companiesSelected } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			companyDetail: state.companyDetail,
			kioskCreationDefinitionData: state.initKioskCreation.definition.data,
			modalShow: state.modal.show,
			companiesSelected: state.companyDetail?.availableOptions?.companyTypes?.hierarchicalSubGroup?.companiesSelected,
		}),
		shallowEqual
	)
	let history = useHistory()
	const match = useRouteMatch()

	const actionsCompanyDetail = bindActionCreators(companiesManagerActionCreators, useDispatch())
	// Mode of page
	const [isUpdate, setIsUpdate] = useState(false)

	// State of article, will contain an object in update case
	const [stateCompany, setStateCompany] = useState({})
	const [previewBase64, setPreviewBase64] = useState('')

	const [errorsPictureBase64Msg, setErrorspictureBase64Msg] = useState('')
	const [imgfile, setImgfile] = useState({}) // Will handle image upload attempt by user
	const [dataLoaded, setDataLoaded] = useState(false)

	// Selected logo if must be
	const [logoNameSelected, setLogoNameSelected] = useState({})

	// Default values of the form
	const [stateDefaultValues, setStateDefaultValues] = useState({
		isDisabled: false,
		idCountry: '0',
		pictureNameSelected: '',
	})

	const [sortedLogoNames, setSortedLogoNames] = useState([])

	// Countries list
	const [countriesList, setCountriesList] = useState([])
	const [countrySelected, setCountrySelected] = useState({}) // For currency setting

	// Divisions list
	const [divisionsList, setDivisionsList] = useState({})
	// Divisions selected (ids)
	const [divisionsSelected, setDivisionsSelected] = useState([])
	// Divisions values (for form usage)
	const [currentDivisionsFieldsValues, setCurrentDivisionsFieldsValues] = useState([])

	// Hierarchial subgroups partnership list
	const [hierarchicalSubGroupsPartnershipList, setHierarchicalSubGroupsPartnershipList] = useState([])
	const [idHierarchicalSubGroupsPartnershipDelete, setIdHierarchicalSubGroupsPartnershipDelete] = useState(-1)
	const [hierarchicalSubGroupsPartnershipDeletedList, setHierarchicalSubGroupsPartnershipDeletedList] = useState([])
	const [hierarchicalSubGroupsPartnershipExportList, setHierarchicalSubGroupsPartnershipExportList] = useState([])
	// Companies list
	const [companiesList, setCompaniesList] = useState(false)
	const [idHierarchicalSubGroupsCompaniesDelete, setIdHierarchicalSubGroupsCompaniesDelete] = useState(-1)
	const [hierarchicalSubGroupsCompaniesDeletedList, setHierarchicalSubGroupsCompaniesDeletedList] = useState([])

	// Hierarchical subgroups list
	const [hierarchicalSubGroupsList, setHierarchicalSubGroupsList] = useState([])
	const [idHierarchicalSubGroupsDelete, setIdHierarchicalSubGroupsDelete] = useState(-1)
	const [hierarchicalSubGroupsDeletedList, setHierarchicalSubGroupsDeletedList] = useState([])

	// Only for update usage
	const [defaultCurrentDivisionsFieldsValues, setDefaultCurrentDivisionsFieldsValues] = useState([])
	const [defaultDivisionsSelected, setDefaultDivisionsSelected] = useState([])
	// Partners list
	const [distributorGroupsList, setDistributorGroupsList] = useState([])
	const [distributorList, setDistributorList] = useState([])

	// Tech support
	const [techSupport, setTechSupport] = useState([])
	// Tech support modal
	const [showTechModal, setShowTechModal] = useState(false)
	// tech modal support kiosk list
	const [techSupportToDelete, setTechSupportToDelete] = useState([])
	// SMS refill modal
	const [showModalSMSRefill, setShowModalSMSRefill] = useState(false)

	const [idDistributionCheck, setIdDistributionCheck] = useState(-1) // It is the index of distribution list, not the proper ID !
	const [idDistriGroupCheck, setIdDistriGroupCheck] = useState(-1) // It is the index of distribution list, not the proper ID !
	const [idTechSupportCheck, setIdTechSupportCheck] = useState(-1) // It is the index of tech support list, not the proper ID !

	const [divisionsRender, setDivisionsRender] = useState('')
	const [divisionsRegistered, setDivisionsRegistered] = useState(false)

	//HANDLER DELETED
	const [isDeleted, setIsDeleted] = useState(false)
	const [elemToDelete, setElemToDelete] = useState()

	// SMS Option, now set directly in company form
	const [isOptionSMSActivated, setIsOptionSMSActivated] = useState(false)

	// When hierarchicalGroupSelected and hierarchicalSubGroupsAvailable contents hierarchicalGroupSelected,
	// We need to clear hierarchicalGroupSelected to prevent having same companies
	const [hasSameSubGroup, setHasSameSubGroup] = useState(false)

	/////////////////////////////// HANDLER //////////////////////////////////////

	const handleRedirect = () => {
		history.push(`${uriList.companies}${uriList.companiesManager}`)
	}

	const handleRedirectKioskProductionList = () => {
		actionsCompanyDetail.setOwner(companyDetail.item.labelToDisplay)
		history.push(`${uriList.kiosksInProduction}${uriList.kioskProductionList}`)
	}

	const handleDeleted = (target, idCheck, isDeleted, elemToDelete) => {
		setIsDeleted(isDeleted)
		setElemToDelete(elemToDelete.id)
		setIsDeleted(isDeleted)
		const distributorGroupsListCp = cloneDeep(distributorGroupsList)
		const distributorListCp = cloneDeep(distributorList)
		const techSupportListCp = cloneDeep(techSupport)
		const hierarchicalSubGroupsPartnershipListCp = cloneDeep(hierarchicalSubGroupsPartnershipList)
		const companiesListCp = cloneDeep(companiesList)
		const hierarchicalSubGroupsListCp = cloneDeep(hierarchicalSubGroupsList)
		if (target === 'distributorGroupsAvailable') {
			setIdDistriGroupCheck(idCheck)
			if (isUndefined(companyDetail.availableOptions.canDisabled)) {
				map(distributorGroupsListCp, (elem) => {
					if (elem.id === elemToDelete.id) {
						elem.active = false
					}
				})
			}
		} else if (target === 'distributorsAvailable') {
			setIdDistributionCheck(idCheck)
			if (isUndefined(companyDetail.availableOptions.canDisabled)) {
				map(distributorListCp, (elem) => {
					if (elem.id === elemToDelete.id) {
						elem.active = false
					}
				})
			}
		} else if (target === 'techSupportAvailable') {
			setTechSupportToDelete(elemToDelete)
			if (elemToDelete.kioskList.length > 0) {
				setIdTechSupportCheck(idCheck)
				setShowTechModal(true)
			} else {
				setIdTechSupportCheck(idCheck)
			}

			//DELETE
		} else if (target === 'hierarchicalSubGroupsAvailableWithExport') {
			let hierarchical_subgroups_partnership_export_list = cloneDeep(hierarchicalSubGroupsPartnershipExportList)
			map(hierarchicalSubGroupsPartnershipListCp, (elem) => {
				if (elem.id === elemToDelete.id) {
					// In update mode and if this element was present in unit call,
					// trigger back call to delete it
					const f = find(companyDetail?.item?.hierarchicalSubGroupsSelectedWithExport, { id: elemToDelete.id })
					if (!isUndefined(f) && isUpdate && isUndefined(find(hierarchicalSubGroupsPartnershipDeletedList, (o) => o === elemToDelete.id))) {
						setIdHierarchicalSubGroupsPartnershipDelete(elemToDelete.id)
						//if we delete a cies that subscribe to herself we need to delete it
						companyDetail.item.companyTypes.hierarchicalSubGroup.companiesSelected.forEach((e) => {
							if (e.idSubGroup === elemToDelete.id && e.idCompany === parseInt(match.params.id)) {
								setIdHierarchicalSubGroupsCompaniesDelete(e.idCompany)
							}
						})
						actionsCompanyDetail.putDeleteCompanySubGroupPartnership(match.params.id, elemToDelete.id)
					} else {
						elem.active = false
						forEach(elem.exportTypes, (e) => {
							_.remove(hierarchical_subgroups_partnership_export_list, (k) => k.id === e.id)
						})
						setHierarchicalSubGroupsPartnershipExportList(hierarchical_subgroups_partnership_export_list)
					}
				}
			})
		} else if (target === 'companiesAvailable') {
			map(companiesListCp, (elem) => {
				if (elem.id === elemToDelete.id) {
					// In update mode and if this element was present in unit call,
					// trigger back call to delete it
					const f = find(companyDetail?.item?.companyTypes?.hierarchicalSubGroup.companiesSelected, (o) => o.idCompany === elemToDelete.id)
					if (!isUndefined(f) && isUpdate && isUndefined(find(hierarchicalSubGroupsCompaniesDeletedList, (o) => o === elemToDelete.id))) {
						setIdHierarchicalSubGroupsCompaniesDelete(elemToDelete.id)
						//if we delete a cies that subscribe to herself we need to delete it
						companyDetail.item.companyTypes.hierarchicalSubGroup.companiesSelected.forEach((e) => {
							if (e.idCompany === elemToDelete.id && !isNull(e.idSubGroup) && elemToDelete.id === parseInt(match.params.id)) {
								setIdHierarchicalSubGroupsPartnershipDelete(e.idSubGroup)
							}
						})
						actionsCompanyDetail.putDeleteCompanySubGroupPartnership(
							elemToDelete.id,
							companyDetail.item.companyTypes.hierarchicalSubGroup.idSubGroup
						)
					} else {
						elem.active = false
					}
				}
			})
		} else if (target === 'hierarchicalSubGroupsAvailable') {
			map(hierarchicalSubGroupsListCp, (elem) => {
				if (elem.id === elemToDelete.id) {
					// In update mode and if this element was present in unit call,
					// trigger back call to delete it
					const f = find(companyDetail?.item?.companyTypes?.hierarchicalGroup?.hierarchicalSubGroupsSelected, (o) => o === elemToDelete.id)
					if (!isUndefined(f) && isUpdate && isUndefined(find(hierarchicalSubGroupsDeletedList, (o) => o === elemToDelete.id))) {
						setIdHierarchicalSubGroupsDelete(elemToDelete.id)
						actionsCompanyDetail.putDeleteCompanySubGroupLink(
							companyDetail.item.companyTypes.hierarchicalGroup.idHierarchicalGroup,
							elemToDelete.id
						)
					} else {
						elem.active = false
						// If hierarchical group attached company is the same as deleted item, we clear the select
						// Searching on item.companyTypes implies that we are in update mode
						const h = find(companyDetail?.item?.companyTypes?.hierarchicalSubGroup?.hierarchicalGroupsAvailable, {
							id: parseInt(getValues('hierarchicalGroupSelected')),
						})
						if (elemToDelete.labelToDisplay === h?.labelToDisplay) {
							setHasSameSubGroup(true)
							setValue('hierarchicalGroupSelected', 0)
						} else {
							setHasSameSubGroup(false)
						}
					}
				}
			})
			//}
		}
		setDistributorGroupsList(distributorGroupsListCp)
		setDistributorList(distributorListCp)
		setTechSupport(techSupportListCp)
		setHierarchicalSubGroupsPartnershipList(hierarchicalSubGroupsPartnershipListCp)
		setCompaniesList(companiesListCp)
		setHierarchicalSubGroupsList(hierarchicalSubGroupsListCp)
	}

	// Tech Support close modal
	const handleCloseModals = () => {
		if (showTechModal) setShowTechModal(false)
		if (showModalSMSRefill) setShowModalSMSRefill(false)
	}

	// Resetting form
	const handleResetForm = () => {
		if (!isUpdate) {
			document.getElementById('pictureBase64').value = ''
			setPreviewBase64('')
			setStateCompany(true)
		} else {
			if (!isNull(companyDetail.item.picture.pictureBase64) && companyDetail.item.picture.pictureBase64.length > 0) {
				const blob = fileFromBase64(companyDetail.item.picture.pictureBase64)
				handleFileReading(blob)
			}
		}

		let hierarchicalSubGroupsPartnership_list = cloneDeep(companyDetail.availableOptions.hierarchicalSubGroupsAvailableWithExport)
		hierarchicalSubGroupsPartnership_list.map((elem) => {
			elem.label = elem.labelToDisplay
			elem.active = false
			return elem
		})
		setHierarchicalSubGroupsPartnershipList(hierarchicalSubGroupsPartnership_list)
		setHierarchicalSubGroupsPartnershipExportList([])

		setDivisionsSelected(defaultDivisionsSelected)
		setCurrentDivisionsFieldsValues(defaultCurrentDivisionsFieldsValues)

		// Back to default states
		reset(stateDefaultValues)
	}

	const handleFileReading = (file) => {
		var reader = new FileReader()

		reader.readAsDataURL(file)
		reader.onload = function () {
			const image = new Image()
			image.src = reader.result

			setValue('pictureBase64', reader.result)
			setPreviewBase64(reader.result)
			setImgfile(file)
			// We need to establish a canvas where we will put uploaded file here
		}
		//reader.onerror = function (error) {}
	}

	const handleDeletePicture = () => {
		document.getElementById('pictureBase64').value = ''
		setValue('pictureBase64', '')
		setPreviewBase64('')
		setValue('pictureNameSelected', '')
	}

	// Sanitize eval calls
	const divisionsValuesEvalHandler = (_obj, obj1, obj2 = '') => {
		return obj2 === '' ? eval(`_obj.${obj1} = ''`) : eval(`_obj.${obj1} = ${obj2}`)
	}

	const errorsEvalHandler = (_errors, obj1, path) => {
		return eval(`_errors.${obj1}${path}`)
	}

	const elemEvalHandler = (_elem, obj1) => {
		return eval(`_elem.${obj1}`)
	}

	const divisionsConfigEvalHandler = (_getDivisionConfig, path) => {
		return eval(`'${_getDivisionConfig.type}${path}'`)
	}

	// When checking divisions
	const handleDivisionsSelected = (id, div) => {
		let div_selected = cloneDeep(divisionsSelected)
		let current_div_fields_values = cloneDeep(currentDivisionsFieldsValues)
		const f = find(divisionsSelected, (o) => o === id) ? true : false
		if (f) {
			// If division was validated, we can't uncheck it
			if (!isUpdate || (isUpdate && !div.isSelected)) {
				div_selected = reject(div_selected, (o) => o === id)
				current_div_fields_values = reject(current_div_fields_values, (o) => o.id === id)
			}
		} else {
			div_selected.push(id)
			// On manufacturer and owner select, there is no "zero" value,
			// the first returned value is considered selected,
			// so we pass the data manually below
			if (!isUndefined(div.manufacturerAvailable)) {
				div.manufacturerSelected = div.manufacturerAvailable[0].id
			}
			if (!isUndefined(div.ownersAvailable)) {
				div.ownerSelected = div.ownersAvailable[0].id
			}
			current_div_fields_values.push(div)

			// Revamp distributors lists, to match with dropdown behaviour
			if (!isUndefined(div.techSupportAvailable)) {
				let tech_support_list = cloneDeep(div.techSupportAvailable)
				map(tech_support_list, (elem) => {
					elem.label = elem.labelToDisplay
					elem.active = false
				})
				setTechSupport(tech_support_list)
			}
			if (!isUndefined(div.distributorGroupsAvailable)) {
				// Add additional properties
				let distrib_group_list = cloneDeep(div.distributorGroupsAvailable)
				map(distrib_group_list, (elem) => {
					elem.label = elem.labelToDisplay
					elem.active = false
				})
				setDistributorGroupsList(distrib_group_list)
			}
			if (!isUndefined(div.distributorsAvailable)) {
				// Add additional properties
				let distrib_list = cloneDeep(div.distributorsAvailable)
				map(distrib_list, (elem) => {
					elem.label = elem.labelToDisplay
					elem.active = false
				})
				setDistributorList(distrib_list)
			}
			if (!isUndefined(div.companiesAvailable)) {
				// Add additional properties
				let companies_list = cloneDeep(div.companiesAvailable)
				map(companies_list, (elem) => {
					elem.label = elem.labelToDisplay
					elem.active = false
				})
				setCompaniesList(companies_list)
			}
			if (!isUndefined(div.hierarchicalSubGroupsAvailable)) {
				// Add additional properties
				let hierarchical_subgroups_list = cloneDeep(div.hierarchicalSubGroupsAvailable)
				map(hierarchical_subgroups_list, (elem) => {
					elem.label = elem.labelToDisplay
					elem.active = false
				})
				setHierarchicalSubGroupsList(hierarchical_subgroups_list)
			}
		}
		setDivisionsSelected(div_selected)
		setCurrentDivisionsFieldsValues(current_div_fields_values)
	}

	// To handle any division field value
	const handleDivisionsValues = (divId, fieldName, value) => {
		let curDivValues = cloneDeep(currentDivisionsFieldsValues)
		let obj = find(curDivValues, (o) => o.id === divId)

		switch (fieldName) {
			case 'hierarchicalGroupSelected':
				// If our selection is on hierarchicalSubGroupsList, activated,
				// We need to clear the item
				if (
					!isEmpty(hierarchicalSubGroupsList) &&
					!isUndefined(companyDetail?.item?.companyTypes?.hierarchicalGroup?.hierarchicalSubGroupsAvailable) &&
					isUpdate
				) {
					const f = find(obj.hierarchicalGroupsAvailable, { id: parseInt(value) })
					const k = findIndex(hierarchicalSubGroupsList, { labelToDisplay: f.labelToDisplay })
					if (k > -1 && setHasSameSubGroup) {
						let currentHierarchicalSubGroupsList = cloneDeep(hierarchicalSubGroupsList)
						currentHierarchicalSubGroupsList[k].active = false
						setHierarchicalSubGroupsList(currentHierarchicalSubGroupsList)
						setHasSameSubGroup(false)
					} else {
						setHasSameSubGroup(true)
					}
				}
				divisionsValuesEvalHandler(obj, fieldName, value)
				break
			case 'manufacturerSelected':
			case 'selectedStoreType':
			case 'ownerSelected':
			case 'seeCustomerTrace':
				divisionsValuesEvalHandler(obj, fieldName, value)
				break
			case 'wedealCommercial':
			case 'currency':
				if (value.length === 0) {
					divisionsValuesEvalHandler(obj, fieldName)
				} else {
					// Expecting a string here
					divisionsValuesEvalHandler(obj, fieldName, value)
				}
				break
			case 'companiesSelected':
			case 'distributorGroupsSelected':
			case 'techSupportSelected':
			case 'distributorsSelected':
			case 'hierarchicalSubGroupsSelected':
				let selected_ids = filter(value, (o) => {
					if (o.active) return o.id
				})
				selected_ids = map(selected_ids, 'id')
				divisionsValuesEvalHandler(obj, fieldName, `[${selected_ids.toString()}]`)
				break
			default:
				break
		}

		setCurrentDivisionsFieldsValues(curDivValues)
	}

	const handleDistributorGroupsList = (id, isChecked) => {
		let distrib_group_list = cloneDeep(distributorGroupsList)
		if (id === 'checkAll') {
			map(distrib_group_list, (elem) => (elem.active = !isChecked))
		} else {
			map(distrib_group_list, (elem) => {
				if (elem.id === id) {
					elem.active = !isChecked
				}
			})
			setIsDeleted(false)
		}
		setDistributorGroupsList(distrib_group_list)
		handleDivisionsValues(8, 'distributorGroupsSelected', distrib_group_list)
	}

	const handleDistributorList = (id, isChecked) => {
		let distrib_list = cloneDeep(distributorList)
		if (id === 'checkAll') {
			distrib_list.map((elem) => (elem.active = !isChecked))
		} else {
			distrib_list.map((elem) => {
				if (elem.id === id) elem.active = !isChecked
				return elem
			})
		}
		setDistributorList(distrib_list)
		handleDivisionsValues(9, 'distributorsSelected', distrib_list)
	}

	// Tech support
	const handleTechSupportList = (id, isChecked) => {
		let tech_support_list = cloneDeep(techSupport)
		if (id === 'checkAll') {
			tech_support_list.map((elem) => (elem.active = !isChecked))
		} else {
			tech_support_list.map((elem) => {
				if (elem.id === id) elem.active = !isChecked
				return elem
			})
		}
		setTechSupport(tech_support_list)
		handleDivisionsValues(2, 'techSupportSelected', tech_support_list)
	}

	const handleDeleteTechSupport = () => {
		const paramId = match.params.id
		actionsCompanyDetail.deleteTechSupport(paramId, techSupportToDelete.id)
		setShowTechModal(false)
	}

	const handleHierarchicalSubGroupsPartnershipList = (id, isChecked) => {
		let hierarchical_subgroups_partnership_list = cloneDeep(hierarchicalSubGroupsPartnershipList)
		let hierarchical_subgroups_partnership_export_list = cloneDeep(hierarchicalSubGroupsPartnershipExportList)
		if (id === 'checkAll') {
			hierarchical_subgroups_partnership_list.map((elem) => {
				isUndefined(find(hierarchical_subgroups_partnership_export_list, (o) => o === elem.id)) &&
					hierarchical_subgroups_partnership_export_list.push(elem.exportTypes)
				elem.active = !isChecked
			})
		} else {
			hierarchical_subgroups_partnership_list.map((elem) => {
				if (elem.id === id) {
					elem.exportTypes.forEach((o) => {
						if (!isChecked && isUndefined(find(hierarchical_subgroups_partnership_export_list, (k) => k.id === o.id))) {
							hierarchical_subgroups_partnership_export_list.push(o)
						} else if (isChecked && !isUndefined(find(hierarchical_subgroups_partnership_export_list, (k) => k.id === o.id))) {
							_.remove(hierarchical_subgroups_partnership_export_list, (k) => k.id === o.id)
						}
					})

					elem.active = !isChecked
					elem.exportTypes.map((o) => {
						o.active = false
						return o
					})
				} else {
					elem.exportTypes.map((o) => {
						if (isUndefined(o.active)) {
							o.active = false
						}
						return o
					})
				}
				return elem
			})
		}

		setHierarchicalSubGroupsPartnershipList(hierarchical_subgroups_partnership_list)
		hierarchical_subgroups_partnership_export_list = _.flattenDeep(hierarchical_subgroups_partnership_export_list)
		hierarchical_subgroups_partnership_export_list.sort((a, b) => (a.exportLabel > b.exportLabel ? 1 : -1))
		// Separated sorted list for export list
		setHierarchicalSubGroupsPartnershipExportList(hierarchical_subgroups_partnership_export_list)
	}

	const handleSubGroupExtract = (subGroupId) => {
		let hierarchical_subgroups_partnership_list = cloneDeep(hierarchicalSubGroupsPartnershipList)
		let hierarchical_subgroups_partnership_export_list = cloneDeep(hierarchicalSubGroupsPartnershipExportList)
		map(hierarchical_subgroups_partnership_list, (e) => {
			e.exportTypes.map((o) => {
				if (subGroupId === o.id) {
					o.active = !o.active
				}
				return o
			})
			//}
		})
		map(hierarchical_subgroups_partnership_export_list, (e) => {
			if (e.id === subGroupId) e.active = !e.active
			return e
		})

		setHierarchicalSubGroupsPartnershipList(hierarchical_subgroups_partnership_list)
		setHierarchicalSubGroupsPartnershipExportList(hierarchical_subgroups_partnership_export_list)
	}

	const handleCompaniesList = (id, isChecked) => {
		let companies_list = cloneDeep(companiesList)
		if (id === 'checkAll') {
			companies_list.map((elem) => (elem.active = !isChecked))
		} else {
			companies_list.map((elem) => {
				if (elem.id === id) elem.active = !isChecked
				return elem
			})
		}
		setCompaniesList(companies_list)
		handleDivisionsValues(7, 'companiesSelected', companies_list)
	}

	const handleHierarchicalSubGroupsList = (id, isChecked) => {
		let hierarchical_sub_group_list = cloneDeep(hierarchicalSubGroupsList)
		if (id === 'checkAll') {
			hierarchical_sub_group_list.map((elem) => (elem.active = !isChecked))
		} else {
			hierarchical_sub_group_list.map((elem) => {
				if (elem.id === id) elem.active = !isChecked
				if (elem.id === id && !isChecked) {
					const f = find(
						companyDetail.item?.companyTypes?.hierarchicalSubGroup?.hierarchicalGroupsAvailable,
						(o) => o.labelToDisplay === elem.labelToDisplay
					)
					if (!isUndefined(f) && companyDetail.item?.companyTypes?.hierarchicalSubGroup?.hierarchicalGroupSelected === f.id) {
						setHasSameSubGroup(true)
						setValue('hierarchicalGroupSelected', 0)
					} else {
						setHasSameSubGroup(false)
					}
				}
				return elem
			})
		}
		setHierarchicalSubGroupsList(hierarchical_sub_group_list)
		handleDivisionsValues(6, 'hierarchicalSubGroupsSelected', hierarchical_sub_group_list)
	}

	// Divisions config
	const divisions_config = [
		{
			id: 1,
			type: 'manufacturer',
			fieldsList: [],
		},
		{
			id: 10,
			type: 'reseller',
			fieldsList: [],
		},
		{
			id: 2,
			type: 'owner',
			fieldsList: ['manufacturerAvailable', 'wedealCommercial', 'techSupportAvailable', 'seeCustomerTrace'],
		},
		{
			id: 3,
			type: 'storeManager',
			fieldsList: ['ownersAvailable'],
		},
		{
			id: 4,
			type: 'store',
			fieldsList: ['availableStoreTypes', 'currency'],
		},
		{
			id: 5,
			type: 'techSupport',
			fieldsList: [],
		},
		{
			id: 8,
			type: 'distributor',
			fieldsList: ['distributorGroupsAvailable'],
		},
		{
			id: 9,
			type: 'distributorGroup',
			fieldsList: ['distributorsAvailable'],
		},
		{
			id: 6,
			type: 'hierarchicalGroup',
			fieldsList: ['hierarchicalSubGroupsAvailable'],
		},
		{
			id: 7,
			type: 'hierarchicalSubGroup',
			fieldsList: ['hierarchicalGroupsAvailable', 'companiesAvailable'],
		},
	]

	const { register, handleSubmit, watch, errors, setValue, getValues, control, reset, clearErrors } = useForm({
		defaultValues: stateDefaultValues,
	})

	const {
		register: registerModalSMSRefill,
		handleSubmit: handleSubmitModalSMSRefill,
		errors: errorsModalSMSRefill,
		clearErrors: clearErrorsSMSRefill,
		getValues: getValuesModalSMSRefill,
	} = useForm()

	// Checks on company status in update mode
	const handleStateCompany = (newValue) => {
		if (isUpdate) {
			// If the new value is enabling, and if it is authorized
			if (newValue && companyDetail.item.canEnabled) {
				setStateCompany(newValue)
				setValue('isDisabled', newValue)
			}
			if (!newValue && companyDetail.item.canDisabled) {
				setStateCompany(newValue)
				setValue('isDisabled', newValue)
			}
		} else {
			setStateCompany(newValue)
			setValue('isDisabled', newValue)
		}
	}

	// When the user choose logo from "database"
	const handleLogoNameSelected = (value) => {
		const f = find(companyDetail.availableOptions.logosAvailable, { logoName: value })
		setLogoNameSelected(f)
		setValue('pictureBase64', `/${f.logoPath}`)
		setPreviewBase64(`/${f.logoPath}`)
		setErrorspictureBase64Msg('')
	}

	// When user wants to refill SMS
	const handleSMSRefill = (data) => {
		actionsCompanyDetail.putSMSRefill(match.params.id, data.smsQuantity)
	}

	/////////////////////////////// CONFIG //////////////////////////////////////

	// Submitting form
	const onSubmit = (data) => {
		let datas = data

		datas.isDisabled = !stateCompany
		datas.optionSMSIsEnabled = isOptionSMSActivated
		datas.numberSMSTrial = isOptionSMSActivated ? null : data.numberSMSTrial

		const selectedSubGroupsPartners = filter(hierarchicalSubGroupsPartnershipList, (o) => o.active)
		const selectedExports = filter(hierarchicalSubGroupsPartnershipExportList, (o) => o.active)
		if (!isEmpty(selectedSubGroupsPartners)) {
			datas.partnerSubGroupsSelected = map(selectedSubGroupsPartners, (e) => {
				let obj = { idSubGroupSelected: e.id }
				const arr = map(e.exportTypes, (k) => {
					const f = find(selectedExports, (o) => o.id === k.id)

					if (!isUndefined(f)) return f.id
					else return null
				})
				obj.exportTypeSelected = arr
				return obj
			})
		}

		// Handling of divisions :
		// First, get all divisions selected
		datas.companyTypesSpec = {} // YUP, it's an object...
		map(currentDivisionsFieldsValues, (elem) => {
			switch (elem.id) {
				case 1:
					datas.companyTypesSpec.manufacturerSpec = {}
					delete datas.manufacturer_optionSMSIsEnabled
					delete datas.manufacturer_numberSMSTrial
					break
				case 2:
					datas.companyTypesSpec.ownerSpec = {
						idManufacturer: elem.manufacturerSelected,
						wedealCommercial: elem.wedealCommercial,
						seeCustomerTrace: elem.seeCustomerTrace ? elem.seeCustomerTrace : false,
						techSupportSelectedIds: elem.techSupportSelected,
					}
					delete datas.owner_optionSMSIsEnabled
					delete datas.owner_numberSMSTrial
					delete datas.idManufacturer
					delete datas.seeCustomerTrace
					break
				case 3:
					datas.companyTypesSpec.storeManagerSpec = {
						idOwner: elem.ownerSelected,
					}
					delete datas.storeManager_optionSMSIsEnabled
					delete datas.storeManager_numberSMSTrial
					delete datas.ownerSelected
					break
				case 4:
					datas.companyTypesSpec.storeSpec = {
						idStoreType: elem.selectedStoreType,
					}
					delete datas.store_optionSMSIsEnabled
					delete datas.store_numberSMSTrial
					break
				case 5:
					datas.companyTypesSpec.techSupportSpec = {}
					delete datas.techSupport_optionSMSIsEnabled
					delete datas.techSupport_numberSMSTrial
					break
				case 6:
					datas.companyTypesSpec.hierarchicalGroupSpec = {
						subGroupsSelectedIds: elem.hierarchicalSubGroupsSelected,
					}
					delete elem.hierarchicalSubGroupsSelected
					break
				case 7:
					datas.companyTypesSpec.hierarchicalSubGroupSpec = {
						idHierarchicalGroupSelected: elem.hierarchicalGroupSelected,
						companiesSelectedIds: map(elem.companiesSelected, (e) => (!isUndefined(e.idCompany) ? e.idCompany : e)),
					}
					break
				case 8:
					datas.companyTypesSpec.distributorSpec = {
						distributorGroupsSelectedIds: elem.distributorGroupsSelected,
						idHierarchicalGroup: elem.hierarchicalGroupSelected,
					}
					delete datas.distributor_optionSMSIsEnabled
					delete datas.distributor_numberSMSTrial
					delete elem.hierarchicalGroupSelected
					break
				case 9:
					datas.companyTypesSpec.distributorGroupSpec = {
						distributorsSelectedIds: elem.distributorsSelected,
					}
					delete datas.distributorGroup_optionSMSIsEnabled
					delete datas.distributorGroup_numberSMSTrial
					break
				case 10:
					datas.companyTypesSpec.resellerSpec = {}
					delete datas.owner_optionSMSIsEnabled
					delete datas.owner_numberSMSTrial
					break
				default:
					break
			}
		})

		// Revamp pictureBase64
		const pict = cloneDeep(datas.pictureBase64)
		const selectedLogo = cloneDeep(datas.pictureNameSelected)
		datas.picture = { pictureBase64: selectedLogo !== '' ? null : pict, pictureNameSelected: selectedLogo !== '' ? selectedLogo : null }

		delete datas.pictureBase64
		delete datas.pictureNameSelected

		// On update, setting fields that are disabled
		if (isUpdate) {
			datas.idCountry = countrySelected.id
		}

		isUpdate ? actionsCompanyDetail.updateCompany(match.params.id, datas) : actionsCompanyDetail.createCompany(datas, props.kioskCreationMode)
	}

	const fileFromBase64 = (data) => {
		// Setting image
		var byteString = atob(data.split(',')[1])
		var mimeString = data.split(',')[0].split(':')[1].split(';')[0]

		var ab = new ArrayBuffer(byteString.length)

		var ia = new Uint8Array(ab)
		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i)
		}
		// write the ArrayBuffer to a blob, and you're done
		var blob = new Blob([ia], { type: mimeString })

		//A Blob() is almost a File() - it's just missing the two properties below which we will add
		blob.lastModifiedDate = new Date()
		blob.name = 'uploadedFile.png'

		return blob
	}

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	// On loading page
	useEffect(() => {
		if (match.url === `${uriList.companies}${uriList.companiesManager}${uriList.companiesEdit}/${match.params.id}`) {
			setIsUpdate(true)
			actionsCompanyDetail.getDataForUpdate(match.params.id)
		} else {
			actionsCompanyDetail.getAvailableListsCompany()
		}

		return function cleanUp() {
			actionsCompanyDetail.resetDataCompany()
		}
	}, [])

	useEffect(() => {
		register({ name: 'pictureBase64' })
	}, [register, translations])

	// We stock uploaded image by user, only to check shortly after if it is valid
	useEffect(() => {
		if (!isEqual(imgfile, {})) {
			const image = new Image()
			const extension = imgfile.name.split('.').pop().toLowerCase()
			const isSuccess = ['png', 'jpg'].indexOf(extension)

			image.src = previewBase64

			var canvas = document.createElement('canvas')
			canvas.width = 151
			canvas.height = 61
			var ctx = canvas.getContext('2d')

			image.onload = function () {
				if (isSuccess < 0 || image.naturalHeight === 0 || image.naturalWidth === 0) {
					document.getElementById('pictureBase64').value = ''
					setPreviewBase64('')
					setErrorspictureBase64Msg(translations['common__message__item_picture_isNotValid'])
					setImgfile({})
				} else {
					let ratioX = 61
					let ratioY = 61
					// Check which side is superior
					if (image.width > image.height) {
						ratioX = 151
						ratioY = (151 * image.height) / image.width
					} else if (image.width < image.height) {
						ratioX = (61 * image.width) / image.height
					}

					ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, ratioX, ratioY)
					setPreviewBase64(canvas.toDataURL(`image/${extension}`))
					setValue('pictureBase64', canvas.toDataURL(`image/${extension}`))
					clearErrors('pictureBase64')
					setErrorspictureBase64Msg('')
					setValue('pictureNameSelected', '')
				}
			}

			image.onerror = function () {
				document.getElementById('pictureBase64').value = ''
				setPreviewBase64('')
				setErrorspictureBase64Msg(translations['common__message__item_picture_isNotValid'])
				setImgfile()
			}
		}
	}, [imgfile])

	// Loading lists after back call
	useEffect(() => {
		if (!isEmpty(companyDetail.availableOptions) && isEmpty(countriesList)) {
			let countries_list = cloneDeep(companyDetail.availableOptions.countriesAvailable)
			setCountriesList(countries_list)
			let divisions_list = cloneDeep(companyDetail.availableOptions.companyTypes)
			setDivisionsList(divisions_list)
			let hierarchicalSubGroupsPartnership_list = cloneDeep(companyDetail.availableOptions.hierarchicalSubGroupsAvailableWithExport)

			// Sorted logo names
			const sorted_logo_names = companyDetail.availableOptions.logosAvailable.sort((a, b) => (a.logoName > b.logoName ? 1 : -1))
			setSortedLogoNames(sorted_logo_names)
			hierarchicalSubGroupsPartnership_list.map((elem) => {
				elem.label = elem.labelToDisplay
				elem.active = false
				return elem
			})

			setHierarchicalSubGroupsPartnershipList(hierarchicalSubGroupsPartnership_list)
			setDataLoaded(true)
		}
	}, [companyDetail.availableOptions])
	// Loading data after back call
	useEffect(() => {
		if (isUpdate && dataLoaded && !isEmpty(companyDetail.item)) {
			setStateCompany(!companyDetail.item.isDisabled)
			setValue('isDisabled', companyDetail.item.isDisabled)

			setValue('companyLabelToDisplay', companyDetail.item.labelToDisplay)
			setValue('companyLabelCommercial', companyDetail.item.labelCommercial)
			setValue('companyLabelToDisplaySMS', companyDetail.item.labelToDisplaySMS)
			setValue('adresse1', companyDetail.item.adress1)
			setValue('adresse2', companyDetail.item.adress2)
			setValue('adresse3', companyDetail.item.adress3)
			setValue('adresse4', companyDetail.item.adress4)
			setValue('postalCode', companyDetail.item.companyCP)
			setValue('city', companyDetail.item.companyCity)
			setValue('idCountry', companyDetail.item.idCountry)
			setValue('phoneCompany', companyDetail.item.companyPhone)
			setValue('emailCompany', companyDetail.item.companyEmail)
			setValue('openingHours', companyDetail.item.openingHours)
			setValue('siret', companyDetail.item.siret)
			setValue('contactName', companyDetail.item.companyContactName)
			setValue('contactEmail', companyDetail.item.companyContactEmail)
			setValue('contactPhone', companyDetail.item.companyContactPhone)

			// SMS part
			setIsOptionSMSActivated(companyDetail.item.optionSMSActivated)
			setValue('numberSMSTrial', companyDetail.item.availableTrialNumberSMS)
			setValue('quantitySmsConsumed', companyDetail.item.quantitySmsConsumed)

			setCountrySelected(find(countriesList, { id: parseInt(companyDetail.item.idCountry) }))

			// Setting picture
			if (!isNull(companyDetail.item.picture.pictureBase64) && companyDetail.item.picture.pictureBase64.length > 0) {
				const blob = fileFromBase64(companyDetail.item.picture.pictureBase64)
				handleFileReading(blob)
			}
			if (!isNull(companyDetail.item.picture.pictureNameSelected)) {
				setValue('pictureNameSelected', companyDetail.item.picture.pictureNameSelected)
				const ar = companyDetail.item.picture.pictureNameSelected.split('/')
				const f = find(companyDetail.availableOptions.logosAvailable, {
					logoName: _.last(ar),
				})
				setLogoNameSelected(f)
				setValue('pictureBase64', `/${f.logoPath}`)
				setPreviewBase64(`/${f.logoPath}`)
				setErrorspictureBase64Msg('')
			}

			// Setting hierarchical subgroup partnership list
			let hierarchical_subgroups_partnership = cloneDeep(hierarchicalSubGroupsPartnershipList)
			let hierarchical_subgroups_partnership_export_list = []

			hierarchical_subgroups_partnership.map((partner) => {
				companyDetail.item.hierarchicalSubGroupsSelectedWithExport.forEach((a) => {
					if (a.id === partner.id) {
						partner.active = true
						a.exportTypesAvailable.forEach((o) => {
							if (isUndefined(find(hierarchical_subgroups_partnership_export_list, (n) => n.id === o.id)))
								hierarchical_subgroups_partnership_export_list.push(o)
						})
					}

					a.exportTypesSelected.forEach((o) => {
						partner.exportTypes.map((exportType) => {
							if (exportType.id === o) {
								exportType.active = true
							}
							if (isUndefined(exportType.active)) exportType.active = false

							return exportType
						})
					})
				})
				return partner
			})

			hierarchical_subgroups_partnership.forEach((partner) => {
				partner.exportTypes.forEach((exportType) => {
					hierarchical_subgroups_partnership_export_list.forEach((mp) => {
						if (isUndefined(mp.active)) mp.active = false
						if (exportType.active && exportType.id === mp.id) {
							mp.active = true
						}
						return mp
					})
				})
			})

			hierarchical_subgroups_partnership_export_list.sort((a, b) => (a.exportLabel > b.exportLabel ? 1 : -1))

			setHierarchicalSubGroupsPartnershipList(hierarchical_subgroups_partnership)
			setHierarchicalSubGroupsPartnershipExportList(hierarchical_subgroups_partnership_export_list)

			// Setting divisions
			let div_selected = []
			let current_div_fields_values = []
			map(companyDetail.item.companyTypes, (div) => {
				if (div.isSelected) {
					div_selected.push(div.id)
					current_div_fields_values.push(div)

					// Revamp distributors lists, to match with dropdown behaviour
					if (!isUndefined(div.distributorGroupsAvailable)) {
						// Add additional properties
						let distrib_group_list = cloneDeep(div.distributorGroupsAvailable)
						map(distrib_group_list, (elem) => {
							elem.label = elem.labelToDisplay
							elem.active = find(div.distributorGroupsSelected, (o) => o === elem.id) ? true : false
						})
						setDistributorGroupsList(distrib_group_list)
					}
					if (!isUndefined(div.distributorsAvailable)) {
						// Add additional properties
						let distrib_list = cloneDeep(div.distributorsAvailable)
						map(distrib_list, (elem) => {
							elem.label = elem.labelToDisplay
							elem.active = find(div.distributorsSelected, (o) => o === elem.id) ? true : false
						})
						setDistributorList(distrib_list)
					}
					if (!isUndefined(div.techSupportAvailable)) {
						let tech_support_list = cloneDeep(div.techSupportAvailable)
						map(tech_support_list, (elem) => {
							elem.label = elem.labelToDisplay
							elem.active = find(div.techSupportSelected, (o) => o === elem.id) ? true : false
							//elem.active = false
						})
						setTechSupport(tech_support_list)
					}

					if (!isUndefined(div.companiesAvailable)) {
						let companies_list = cloneDeep(div.companiesAvailable)
						map(companies_list, (elem) => {
							elem.label = elem.labelToDisplay
							elem.active = find(div.companiesSelected, (o) => o.idCompany === elem.id) ? true : false
						})
						setCompaniesList(companies_list)
					}
					if (!isUndefined(div.hierarchicalSubGroupsAvailable)) {
						let hierarchical_subgroups_list = cloneDeep(div.hierarchicalSubGroupsAvailable)
						map(hierarchical_subgroups_list, (elem) => {
							elem.label = elem.labelToDisplay
							elem.active = find(div.hierarchicalSubGroupsSelected, (o) => o === elem.id) ? true : false

							// Checking if hierarchical group selected AND same company is in hierarchicalSubGroupsSelected
							// The next time we change the hierarchical group selected, we remove this company from hierarchicalSubGroupsSelected
							const ind = findIndex(
								companyDetail.item.companyTypes.hierarchicalSubGroup.hierarchicalGroupsAvailable,
								(o) =>
									o.labelToDisplay === elem.labelToDisplay &&
									o.id === companyDetail.item.companyTypes.hierarchicalSubGroup.hierarchicalGroupSelected
							)
							if (ind > -1 && elem.active) {
								setHasSameSubGroup(true)
							}
							//elem.active = false
						})
						setHierarchicalSubGroupsList(hierarchical_subgroups_list)
					}
				}
			})
			setDivisionsSelected(div_selected)
			setCurrentDivisionsFieldsValues(current_div_fields_values)

			// For reset usage
			setDefaultCurrentDivisionsFieldsValues(current_div_fields_values)
			setDefaultDivisionsSelected(div_selected)

			setStateDefaultValues(getValues())
		} else if (props.kioskCreationMode && !props.noDataPassed && !isEqual(kioskCreationDefinitionData, {}) && dataLoaded) {
			// Setting store division fields
			let div_selected = cloneDeep(divisionsSelected)
			let current_div_fields_values = cloneDeep(currentDivisionsFieldsValues)

			const div = divisions_config[4]

			div_selected.push(4)
			current_div_fields_values.push(div)
			setDivisionsSelected(div_selected)

			let obj = find(current_div_fields_values, (o) => o.id === divisions_config[4].id)

			obj.selectedStoreType = kioskCreationDefinitionData.userCreatedStoreInfo.idStoreType

			setCurrentDivisionsFieldsValues(current_div_fields_values)

			// Setting country
			const country = find(countriesList, { countryName: kioskCreationDefinitionData.userCreatedStoreInfo.country })
			if (!isUndefined(country)) {
				setValue('idCountry', country.id)
				setCountrySelected(country)
			}

			// Setting basic fields
			setValue('companyLabelCommercial', kioskCreationDefinitionData.userCreatedStoreInfo.storeLabelCommercial)
			setValue('adresse1', kioskCreationDefinitionData.userCreatedStoreInfo.storeAddress)
			setValue('postalCode', kioskCreationDefinitionData.userCreatedStoreInfo.storePostalCode)
			setValue('city', kioskCreationDefinitionData.userCreatedStoreInfo.storeCity)
			setValue('phoneCompany', kioskCreationDefinitionData.userCreatedStoreInfo.storePhoneNumber)
			setValue('emailCompany', kioskCreationDefinitionData.userCreatedStoreInfo.storeEmail)
			setValue('siret', kioskCreationDefinitionData.userCreatedStoreInfo.storeSiret)
		}
	}, [companyDetail.item, dataLoaded, kioskCreationDefinitionData?.userCreatedStoreInfo])

	// When selected divisions are set, begin rendering
	useEffect(() => {
		if (!isEmpty(divisionsList) && !isEmpty(divisionsSelected) && translations) {
			setDivisionsRender(
				map(divisions_config, (elem) => {
					// If the property exist in divisionsList
					const obj = get(divisionsList, elem.type)
					if (!isUndefined(obj) && find(divisionsSelected, (o) => o === elem.id)) {
						// Check fields values what we currently have,
						// So we can handle it
						const current_val_fields = find(currentDivisionsFieldsValues, (o) => o.id === elem.id)
						let target = ''
						// Now we gonna search what fields we require
						return (
							<Fragment>
								<div>
									<DivisionTitle>{`${translations['page__companiesManagement__detail__divisionSpecificitySheet_title']} : ${
										translations[obj.translationKey]
									}`}</DivisionTitle>
									<div></div>
									{map(elem.fieldsList, (fieldName) => {
										switch (fieldName) {
											case 'manufacturerAvailable':
												return (
													<Fragment>
														<LabelTextCustom>
															{
																translations[
																	'page__companiesManagement__detail__companySheet_owner_manufacturerSelection'
																]
															}
															* :
														</LabelTextCustom>
														<div>
															<SelectInputWrapper>
																<SelectInput
																	width="216"
																	name="idManufacturer"
																	ref={register({
																		required: {
																			value: true,
																			message: translations['common__text__requiredField'],
																		},
																		validate: (value) => value > 0 || translations['common__text__requiredField'],
																	})}
																	onChange={(e) =>
																		handleDivisionsValues(elem.id, 'manufacturerSelected', e.target.value)
																	}
																>
																	{map(obj.manufacturerAvailable, (manufacturer, id) => {
																		return (
																			<option key={id} value={manufacturer.id}>
																				{manufacturer.labelToDisplay}
																			</option>
																		)
																	})}
																</SelectInput>
															</SelectInputWrapper>
															{errors.idManufacturer && <ErrorInputMsg>{errors.idManufacturer.message}</ErrorInputMsg>}
														</div>
													</Fragment>
												)

											case 'availableStoreTypes':
												return (
													<Fragment>
														<LabelTextCustom>
															{
																translations[
																	'page__companiesManagement__detail__companySheet__field__store_storeTypeSelection'
																]
															}{' '}
															:
														</LabelTextCustom>
														<div>
															<SelectInputWrapper>
																<SelectInputCustom
																	width="216"
																	name="idStoreType"
																	className={watch('idStoreType') > 0 ? 'active' : ''}
																	ref={register({})}
																	onChange={(e) =>
																		handleDivisionsValues(elem.id, 'selectedStoreType', e.target.value)
																	}
																>
																	<OptionCustom value="0">
																		{
																			translations[
																				'page__companiesManagement__detail__companySheet__placeholder__store_storeTypeSelection'
																			]
																		}
																	</OptionCustom>
																	{map(obj.availableStoreTypes, (storeType, id) => {
																		return (
																			<OptionCustom key={id} value={storeType.idStoreType} target={true}>
																				{translations[storeType.translationKey]}
																			</OptionCustom>
																		)
																	})}
																</SelectInputCustom>
															</SelectInputWrapper>
															{errors.idStoreType && <ErrorInputMsg>{errors.idStoreType.message}</ErrorInputMsg>}
														</div>
													</Fragment>
												)

											case 'wedealCommercial':
												return (
													<Fragment>
														<LabelTextCustom>
															{
																translations[
																	'page__companiesManagement__detail__companySheet_owner_commercialNameWedeal'
																]
															}{' '}
															:
														</LabelTextCustom>
														<InputWrapper>
															<InputLogin
																name={`${elem.type}_wedealCommercial`}
																type="text"
																placeholder={
																	translations[
																		'page__companiesManagement__detail__companySheet_owner_commercialNameWedeal_prefilled'
																	]
																}
																ref={register({
																	maxLength: {
																		value: 99,
																		message: `50 ${translations['common__text__charMax']}`,
																	},
																	minLength: {
																		value: 1,
																		message: `1 ${translations['common__text__charMin']}`,
																	},
																})}
																onChange={(e) => handleDivisionsValues(elem.id, 'wedealCommercial', e.target.value)}
															/>
															{errorsEvalHandler(errors, elem.type, '_wedealCommercial') && (
																<ErrorInputMsg>
																	{errorsEvalHandler(errors, elem.type, '_wedealCommercial.message')}
																</ErrorInputMsg>
															)}
														</InputWrapper>
													</Fragment>
												)

											case 'ownersAvailable':
												return (
													<Fragment>
														<LabelTextCustom>
															{
																translations[
																	'page__companiesManagement__detail__companySheet_storeManager_ownerSelection'
																]
															}
															* :
														</LabelTextCustom>
														<div>
															<SelectInputWrapper>
																<SelectInputCustom
																	width="216"
																	name="ownerSelected"
																	className={watch('ownerSelected') > 0 ? 'active' : ''}
																	ref={register({
																		required: {
																			value: true,
																			message: translations['common__text__requiredField'],
																		},
																		validate: (value) => value > 0 || translations['common__text__requiredField'],
																	})}
																	onChange={(e) => handleDivisionsValues(elem.id, 'ownerSelected', e.target.value)}
																>
																	<OptionCustom value="0" hidden>
																		Sélectionner le propriétaire{' '}
																	</OptionCustom>
																	{map(obj.ownersAvailable, (owner, id) => {
																		return (
																			<OptionCustom key={id} value={owner.id} target={true}>
																				{owner.labelToDisplay}
																			</OptionCustom>
																		)
																	})}
																</SelectInputCustom>
															</SelectInputWrapper>
															{errors.ownerSelected && <ErrorInputMsg>{errors.ownerSelected.message}</ErrorInputMsg>}
														</div>
													</Fragment>
												)

											case 'currency':
												return (
													<Fragment>
														<LabelTextCustom>
															{translations['page__companiesManagement__detail__companySheet_store_currency']} :
														</LabelTextCustom>

														<DeviseSpan>{countrySelected?.currency?.symbol}</DeviseSpan>
													</Fragment>
												)

											case 'distributorGroupsAvailable':
												target = 'distributorGroupsAvailable'
												return (
													<Fragment>
														<LabelTextCustom>
															{
																translations[
																	'page__companiesManagement__detail__companySheet_distributor_distriGroupSelection'
																]
															}{' '}
															:
														</LabelTextCustom>
														<DropdownCheckboxHandler>
															<DropdownCheckbox
																title={translations['common__text__division_distributorGroup']}
																data={distributorGroupsList || []}
																paperTopPosition={'40'}
																selectActionsHandler={handleDistributorGroupsList}
																submitOnClose={() => null}
																target={'distributorGroupsAvailable'}
															/>
															<div>
																{map(distributorGroupsList, (elem, id) => {
																	return elem.active ? (
																		<PartnerItem>
																			<Tooltip
																				tooltipId={`companyDetail_actionResetDistriGroup_${elem.id}`}
																				translationsKey={'tooltip__admin__global__deletedChooice'}
																				position="left"
																			>
																				<SearchResetCustom
																					onClick={() => {
																						handleDeleted(target, id, true, elem)
																					}}
																				/>
																			</Tooltip>
																			<LabelTextCustom>{elem.label}</LabelTextCustom>
																		</PartnerItem>
																	) : null
																})}
															</div>
														</DropdownCheckboxHandler>
													</Fragment>
												)

											case 'distributorsAvailable':
												target = 'distributorsAvailable'
												return (
													<Fragment>
														<LabelTextCustom>
															{
																translations[
																	'page__companiesManagement__detail__companySheet_distriGroup_distributorSelection'
																]
															}{' '}
															:
														</LabelTextCustom>
														<DropdownCheckboxHandler>
															<DropdownCheckbox
																title={translations['common__text__division_distributor']}
																data={distributorList || []}
																paperTopPosition={'40'}
																selectActionsHandler={handleDistributorList}
																submitOnClose={() => null}
																target={'distributorsAvailable'}
															/>
															<div>
																{map(distributorList, (elem, id) => {
																	return elem.active ? (
																		<PartnerItem>
																			<Tooltip
																				tooltipId={'companyDetail_actionResetDistri'}
																				translationsKey={'tooltip__admin__global__deletedChooice'}
																				position="left"
																			>
																				<SearchResetCustom
																					onClick={() => {
																						handleDeleted(target, id, true, elem)
																					}}
																				/>
																			</Tooltip>
																			<LabelTextCustom>{elem.label}</LabelTextCustom>
																		</PartnerItem>
																	) : null
																})}
															</div>
														</DropdownCheckboxHandler>
													</Fragment>
												)

											case 'techSupportAvailable':
												target = 'techSupportAvailable'
												return (
													<Fragment>
														<LabelTextCustom>{`${translations['page__companiesManagement__maintainer__select_partnership']} :`}</LabelTextCustom>
														<DropdownCheckboxHandler>
															<DropdownCheckbox
																title={translations['page__initKiosksProduction__kioskList_filters_maintainer']}
																data={techSupport || []}
																paperTopPosition={'40'}
																selectActionsHandler={handleTechSupportList}
																submitOnClose={() => null}
																target={'techSupportAvailable'}
															/>
															<div>
																{map(techSupport, (elem, id) => {
																	return elem.active ? (
																		<PartnerItem>
																			<Tooltip
																				tooltipId={'companyDetail_actionResetDistri'}
																				translationsKey={'tooltip__admin__global__deletedChooice'}
																				position="left"
																			>
																				<SearchResetCustom
																					onClick={() => {
																						handleDeleted(target, id, true, elem)
																					}}
																				/>
																			</Tooltip>
																			<LabelTextCustom>{elem.label}</LabelTextCustom>
																		</PartnerItem>
																	) : null
																})}
															</div>
														</DropdownCheckboxHandler>
													</Fragment>
												)

											case 'hierarchicalGroupsAvailable':
												return (
													<Fragment>
														<LabelTextCustom>
															{translations['page__companiesManagement__detail__companySheet_form_attachedSubGroup']} :
														</LabelTextCustom>
														<div>
															<SelectInputWrapper>
																<SelectInputCustom
																	width="216"
																	name="hierarchicalGroupSelected"
																	className={watch('hierarchicalGroupSelected') > 0 ? 'active' : ''}
																	ref={register({})}
																	onChange={(e) =>
																		handleDivisionsValues(elem.id, 'hierarchicalGroupSelected', e.target.value)
																	}
																>
																	<OptionCustom value="0">
																		{
																			translations[
																				'page__companiesManagement__detail__companySheet_form_placeholder_hierarchicalGroup'
																			]
																		}
																	</OptionCustom>
																	{map(obj.hierarchicalGroupsAvailable, (hierarGroup, id) => {
																		return (
																			<OptionCustom key={id} value={hierarGroup.id} target={true}>
																				{hierarGroup.labelToDisplay}
																			</OptionCustom>
																		)
																	})}
																</SelectInputCustom>
															</SelectInputWrapper>
															{errors.hierarchicalGroupSelected && (
																<ErrorInputMsg>{errors.hierarchicalGroupSelected.message}</ErrorInputMsg>
															)}
														</div>
													</Fragment>
												)

											case 'seeCustomerTrace':
												return (
													<Fragment>
														<LabelTextCustom>
															{translations['page__companiesManagement__detail__companySheet_owner_seeCustomerTrace']}:
														</LabelTextCustom>
														<Controller
															control={control}
															name={`${elem.type}_seeCustomerTrace`}
															as={ToggleFilters}
															checked={current_val_fields?.seeCustomerTrace}
															onChangeHandler={() =>
																handleDivisionsValues(
																	elem.id,
																	'seeCustomerTrace',
																	!current_val_fields?.seeCustomerTrace
																)
															}
															rules={register({
																required: {
																	value: true,
																	message: translations['common__text__requiredField'],
																},
															})}
															labelPrev={translations['common__text__yes']}
															labelNext={translations['common__text__no']}
															size="large"
															reverseCheck
														/>
													</Fragment>
												)

											case 'companiesAvailable':
												target = 'companiesAvailable'
												return (
													<Fragment>
														<LabelTextCustom>{`${translations['page__companiesManagement__detail__companySheet_form_attachedCompanies']} :`}</LabelTextCustom>
														<DropdownCheckboxHandler>
															<DropdownCheckbox
																title={
																	translations[
																		'page__companiesManagement__detail__companySheet_form_placeholder_attachedCompanies'
																	]
																}
																data={companiesList || []}
																paperTopPosition={'40'}
																selectActionsHandler={handleCompaniesList}
																submitOnClose={() => null}
																target={'companiesAvailable'}
															/>
															<div>
																{map(companiesList, (elem, id) => {
																	return elem.active ? (
																		<PartnerItem>
																			<Tooltip
																				tooltipId={'companyDetail_actionResetCompany'}
																				translationsKey={'tooltip__admin__global__deletedChooice'}
																				position="left"
																			>
																				<SearchResetCustom
																					onClick={() => {
																						handleDeleted(target, id, true, elem)
																					}}
																				/>
																			</Tooltip>
																			<LabelTextCustom>{elem.labelToDisplay}</LabelTextCustom>
																		</PartnerItem>
																	) : null
																})}
															</div>
														</DropdownCheckboxHandler>
													</Fragment>
												)

											case 'hierarchicalSubGroupsAvailable':
												target = 'hierarchicalSubGroupsAvailable'
												return (
													<Fragment>
														<LabelTextCustom>{`${translations['page__companiesManagement__detail__companySheet_form_attachedHierarchicalGroup']} :`}</LabelTextCustom>
														<DropdownCheckboxHandler>
															<DropdownCheckbox
																title={
																	translations[
																		'page__companiesManagement__detail__companySheet_form_subGroupDivision'
																	]
																}
																data={hierarchicalSubGroupsList || []}
																paperTopPosition={'40'}
																selectActionsHandler={handleHierarchicalSubGroupsList}
																submitOnClose={() => null}
																target={'hierarchicalSubGroupsAvailable'}
															/>
															<div>
																{map(hierarchicalSubGroupsList, (elem, id) => {
																	return elem.active ? (
																		<PartnerItem>
																			<Tooltip
																				tooltipId={'companyDetail_actionResetSubGroup'}
																				translationsKey={'tooltip__admin__global__deletedChooice'}
																				position="left"
																			>
																				<SearchResetCustom
																					onClick={() => {
																						handleDeleted(target, id, true, elem)
																					}}
																				/>
																			</Tooltip>
																			<LabelTextCustom>{elem.labelToDisplay}</LabelTextCustom>
																		</PartnerItem>
																	) : null
																})}
															</div>
														</DropdownCheckboxHandler>
													</Fragment>
												)
											default:
												break
										}
									})}
								</div>
							</Fragment>
						)
					}
				})
			)
			setDivisionsRegistered(true)
		} else {
			setDivisionsRender('')
			setDivisionsRegistered(false)
		}
	}, [divisionsSelected, translations, errors, currentDivisionsFieldsValues, countrySelected, isDeleted])

	// When features have been rendered AND registered in form,
	// loading item data
	useEffect(() => {
		if (divisionsRegistered && (isUpdate || !isEqual(kioskCreationDefinitionData, {}))) {
			// We must register values,
			// And also prepare already data to be set for form validation
			const divisionsValues = cloneDeep(currentDivisionsFieldsValues)

			map(divisionsValues, (elem) => {
				const getDivisionConfig = find(divisions_config, { id: elem.id })

				map(getDivisionConfig.fieldsList, (field) => {
					switch (field) {
						/*case 'optionSMSActivated':
							!isNull(elemEvalHandler(elem, field)) &&
								setValue(divisionsConfigEvalHandler(getDivisionConfig, '_optionSMSIsEnabled'), elemEvalHandler(elem, field))
							break
						case 'availableTrialNumberSMS':
							!isNull(elemEvalHandler(elem, field)) &&
								setValue(divisionsConfigEvalHandler(getDivisionConfig, '_numberSMSTrial'), elemEvalHandler(elem, field))
							break*/
						case 'ownersAvailable':
							!isNull(elemEvalHandler(elem, 'ownerSelected')) && setValue('ownerSelected', elem.ownerSelected)
							break
						case 'availableStoreTypes':
							!isNull(elemEvalHandler(elem, 'selectedStoreType')) && setValue('idStoreType', elem.selectedStoreType)
							break
						case 'manufacturerAvailable':
							!isNull(elemEvalHandler(elem, 'manufacturerSelected')) && setValue('idManufacturer', elem.manufacturerSelected)
							break
						case 'wedealCommercial':
							!isNull(elemEvalHandler(elem, field)) &&
								setValue(divisionsConfigEvalHandler(getDivisionConfig, '_wedealCommercial'), elemEvalHandler(elem, field))
							break
						case 'hierarchicalGroupsAvailable':
							!isNull(elemEvalHandler(elem, 'hierarchicalGroupSelected')) &&
								!hasSameSubGroup &&
								setValue('hierarchicalGroupSelected', elem.hierarchicalGroupSelected)
							break
						case 'seeCustomerTrace':
							!isNull(elemEvalHandler(elem, field)) &&
								setValue(divisionsConfigEvalHandler(getDivisionConfig, '_seeCustomerTrace'), elemEvalHandler(elem, field))
							break
						default:
							break
					}
				})
			})
		}
	}, [divisionsRender, divisionsRegistered])
	// When distribution group id is selected
	useEffect(() => {
		// In update mode, we need a back call to check if we can disable
		if (idDistriGroupCheck > -1) {
			if (isUpdate) {
				// Back call
				const distrib_group_list = cloneDeep(distributorGroupsList)
				// Before back call, check if id was already in validated list
				// We only check for a validated id, not a newly one

				if (
					!isUndefined(
						find(
							companyDetail.item.companyTypes.distributor.distributorGroupsSelected,
							(o) => o === distrib_group_list[idDistriGroupCheck].id
						)
					)
				) {
					actionsCompanyDetail.checkDisablingGroupDistribution(match.params.id, distrib_group_list[idDistriGroupCheck].id)
				} else {
					handleDistributorGroupsList(distributorGroupsList[idDistriGroupCheck].id, true)
				}
			} else if (!isDeleted) {
				handleDistributorGroupsList(elemToDelete, false)
			}
		}
	}, [idDistriGroupCheck])

	// we need to check if we have kiosk to make an instant delete or to inform user by display modal
	useEffect(() => {
		// We need to make sure that techsupportid delete was selected in unit call to make the back-end call
		// If it is a newly one and we want to remove it, we don't need any control => techSupport is not registered yet
		if (
			isUpdate &&
			!isEmpty(techSupportToDelete) &&
			techSupportToDelete.kioskList.length <= 0 &&
			!isUndefined(find(companyDetail?.item?.companyTypes?.owner?.techSupportSelected, (o) => o === techSupport[idTechSupportCheck]?.id))
		) {
			handleDeleteTechSupport()
		} else {
			if (!isEmpty(techSupport)) handleTechSupportList(techSupport[idTechSupportCheck]?.id, true)
		}
	}, [idTechSupportCheck, techSupportToDelete])

	useEffect(() => {
		if (isUpdate && !isEqual(companyDetail.maintainerChecked, {})) {
			if (companyDetail.maintainerChecked.canDisabled) {
				handleTechSupportList(techSupport[idTechSupportCheck].id, true)
			}
		}
	}, [companyDetail.maintainerChecked])

	// When back was called after check on distribution group
	useEffect(() => {
		if (isUpdate && !isEqual(companyDetail.distributionGroupChecked, {})) {
			if (companyDetail.distributionGroupChecked.canDisabled) {
				handleDistributorGroupsList(distributorGroupsList[idDistriGroupCheck].id, true)
			}
		}
	}, [companyDetail.distributionGroupChecked])

	// When distribution id is selected
	useEffect(() => {
		// In update mode, we need a back call to check if we can disable
		if (isUpdate && idDistributionCheck > -1) {
			// Back call
			const distrib_list = cloneDeep(distributorList)
			// Before back call, check if id was already in validated list
			// We only check for a validated id, not a newly one
			if (
				!isUndefined(
					find(companyDetail.item.companyTypes.distributorGroup.distributorsSelected, (o) => o === distrib_list[idDistributionCheck].id)
				)
			) {
				actionsCompanyDetail.checkDisablingDistribution(match.params.id, distrib_list[idDistributionCheck].id)
			} else {
				handleDistributorList(distributorList[idDistributionCheck].id, true)
			}
		}
	}, [idDistributionCheck])

	// When back was called after check on distribution
	useEffect(() => {
		if (isUpdate && !isEqual(companyDetail.distributionChecked, {})) {
			if (companyDetail.distributionChecked.canDisabled) {
				handleDistributorList(distributorList[idDistributionCheck].id, true)
			}
		}
	}, [companyDetail.distributionChecked])

	useEffect(() => {
		if (isDeleted) {
			setIsDeleted(false)
		}
	}, [distributorGroupsList, distributorList])

	// to allow deleted action on the same element, we need to reset some states
	useEffect(() => {
		if (!modalShow) {
			setIdDistributionCheck(-1)
			setIdDistriGroupCheck(-1)
			setIdTechSupportCheck(-1)
		}
	}, [modalShow])

	// When user has refilled SMS quantity
	useEffect(() => {
		if (companyDetail.update && showModalSMSRefill) {
			handleCloseModals()
			let newValue = parseInt(getValues('numberSMSTrial'))
			newValue += parseInt(getValuesModalSMSRefill('smsQuantity'))
			setValue('numberSMSTrial', newValue)
			clearErrorsSMSRefill()
		}
	}, [showModalSMSRefill, companyDetail.update])
	// When user is removing hierarchical subgroup in update mode
	useEffect(() => {
		if (companyDetail.update && idHierarchicalSubGroupsPartnershipDelete > -1) {
			const hierarchicalSubGroupsPartnershipListCp = cloneDeep(hierarchicalSubGroupsPartnershipList)
			let hierarchical_subgroups_partnership_export_list = cloneDeep(hierarchicalSubGroupsPartnershipExportList)
			map(hierarchicalSubGroupsPartnershipListCp, (elem) => {
				if (elem.id === idHierarchicalSubGroupsPartnershipDelete) {
					elem.active = false
					forEach(elem.exportTypes, (e) => {
						_.remove(hierarchical_subgroups_partnership_export_list, (k) => k.id === e.id)
					})
				}
			})
			const hierarchicalSubGroupsPartnershipDeletedListCp = cloneDeep(hierarchicalSubGroupsPartnershipDeletedList)
			hierarchicalSubGroupsPartnershipDeletedListCp.push(idHierarchicalSubGroupsPartnershipDelete)
			setHierarchicalSubGroupsPartnershipDeletedList(hierarchicalSubGroupsPartnershipDeletedListCp)

			setIdHierarchicalSubGroupsPartnershipDelete(-1)
			setHierarchicalSubGroupsPartnershipList(hierarchicalSubGroupsPartnershipListCp)
			setHierarchicalSubGroupsPartnershipExportList(hierarchical_subgroups_partnership_export_list)
		} else if (companyDetail.update && idHierarchicalSubGroupsCompaniesDelete > -1) {
			const hierarchicalSubGroupsCompaniesDeletedListCp = cloneDeep(hierarchicalSubGroupsCompaniesDeletedList)
			hierarchicalSubGroupsCompaniesDeletedListCp.push(idHierarchicalSubGroupsCompaniesDelete)
			setHierarchicalSubGroupsCompaniesDeletedList(hierarchicalSubGroupsCompaniesDeletedListCp)

			handleCompaniesList(idHierarchicalSubGroupsCompaniesDelete, true)
			setIdHierarchicalSubGroupsCompaniesDelete(-1)
		} else if (companyDetail.update && idHierarchicalSubGroupsDelete > -1) {
			const hierarchicalSubGroupsDeletedListCp = cloneDeep(hierarchicalSubGroupsDeletedList)
			hierarchicalSubGroupsDeletedListCp.push(idHierarchicalSubGroupsDelete)
			setHierarchicalSubGroupsDeletedList(hierarchicalSubGroupsDeletedListCp)

			// If hierarchical group attached company is the same as deleted item, we clear the select
			const h = find(companyDetail?.item?.companyTypes?.hierarchicalGroup?.hierarchicalSubGroupsAvailable, {
				id: idHierarchicalSubGroupsDelete,
			})

			const g = find(companyDetail?.item?.companyTypes?.hierarchicalSubGroup?.hierarchicalGroupsAvailable, {
				id: parseInt(getValues('hierarchicalGroupSelected')),
			})

			if (g.labelToDisplay === h.labelToDisplay) {
				setHasSameSubGroup(true)
				setValue('hierarchicalGroupSelected', 0)
			} else {
				setHasSameSubGroup(false)
			}

			handleHierarchicalSubGroupsList(idHierarchicalSubGroupsDelete, true)
			setIdHierarchicalSubGroupsDelete(-1)
		}
	}, [idHierarchicalSubGroupsPartnershipDelete, idHierarchicalSubGroupsCompaniesDelete, idHierarchicalSubGroupsDelete, companyDetail.update])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			{/* MODAL MAINTENEUR*/}
			<Modals
				showModal={showTechModal}
				//showModal={showTechModal}
				closeModalHandler={handleCloseModals}
				title={translations['modal__companiesManagement__maintainer__companyDisabled_header']}
				width={555}
				icon={true}
				level="error"
			>
				{!isUndefined(techSupportToDelete.numberOfKiosk) && (
					<TextModal>
						{StringFormatter.ResponseMessageParser(translations['modal__companiesManagement__maintainer__companyDisabled_body'], [
							techSupportToDelete.numberOfKiosk.toString(),
						])}
					</TextModal>
				)}
				{!isUndefined(techSupportToDelete.numberOfKiosk) && (
					<WrapperTextModal>
						{map(techSupportToDelete.kioskList, (elem) => (
							<TextModal padding={14}>{`${elem.labelToOwner} -  ${elem.labelToDisplay}`}</TextModal>
						))}
					</WrapperTextModal>
				)}
				<ButtonWrapper>
					<Button
						actionHandler={handleCloseModals}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={handleDeleteTechSupport}
						text={translations['common__text__validate']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>

			<Modals
				title={translations['modal__companiesManagement__title_smsRecharge']}
				showModal={showModalSMSRefill}
				closeModalHandler={handleCloseModals}
				icon={true}
			>
				<form onSubmit={handleSubmitModalSMSRefill(handleSMSRefill)}>
					<TextModalCustom>
						<LabelTextCustom>{translations['modal__companiesManagement__body_smsRecharge']} :</LabelTextCustom>
						<div>
							<InputLogin
								name="smsQuantity"
								type="text"
								placeholder={translations['common__text__prefilled_informField']}
								ref={registerModalSMSRefill({
									pattern: {
										value: RegExp(/^[0-9]+$/),
										message: translations['page__companiesManagement__detail__companySheet_form_smsExpeditor_invalidChars'],
									},
									maxLength: {
										value: 3,
										message: `3 ${translations['common__text__charMax']}`,
									},
									minLength: {
										value: 1,
										message: `1 ${translations['common__text__charMin']}`,
									},
									validate: (value) =>
										(isNumber(parseInt(value)) && value.length > 0 && parseInt(value) > 0) ||
										translations['common__text__requiredField'],
								})}
							/>
							{errorsModalSMSRefill.smsQuantity && <ErrorInputMsg>{errorsModalSMSRefill.smsQuantity.message}</ErrorInputMsg>}
						</div>
					</TextModalCustom>
					<ButtonWrapper>
						<Button
							actionHandler={handleCloseModals}
							text={translations['common__text__cancel']}
							bgColor={Theme.colors.error}
							margin="true"
							img={Cancel}
						/>
						<Button
							//actionHandler={handleSMSRefill}
							text={translations['common__text__validate']}
							bgColor={Theme.colors.validation}
							img={Validation}
						/>
					</ButtonWrapper>
				</form>
			</Modals>

			<CompanyDetailWrapper>
				<PageWrapperLinks>
					<Button goBack weight="bold" actionHandler={() => handleRedirect()} text={translations['common__text__previousPage']} />
				</PageWrapperLinks>
				<PageWrapperSecondaryLinks>
					<Button
						weight="bold"
						actionHandler={() => history.push(`${uriList.users}${uriList.usersManager}`)}
						text={translations['page__companiesManagement__detail__button_users_management']}
					/>
					{isUpdate && (
						<Button
							weight="bold"
							text={translations['page__companiesManagement__detail__action_kioskManagement']}
							actionHandler={() => handleRedirectKioskProductionList()}
						/>
					)}
				</PageWrapperSecondaryLinks>
				<form onSubmit={handleSubmit(onSubmit)}>
					<LineTableHeader>
						<PageTitleCustom>
							{isUpdate
								? translations['page__companiesManagement__modify_companyData_title']
								: translations['page__companiesManagement__create_companyData_title']}
						</PageTitleCustom>
						<PageWrapperActions>
							<Tooltip
								tooltipId={'companyDetail_actionSubmit'}
								translationsKey={'tooltip__admin__global__validatedAction'}
								position="left"
							>
								<PageWrapperActionValidate type="submit" />
							</Tooltip>
							{props.kioskCreationMode && (
								<Tooltip tooltipId={'kioskScopeClose'} translationsKey={'tooltip__admin__global__cancelClose'} position={'left'}>
									<ImgButton
										img={Cancel}
										action={() => props.closeModalHandler()}
										color={Theme.colors.error}
										margin={'5px'}
										hover={Theme.colors.hoverError}
									/>
								</Tooltip>
							)}
							<Tooltip tooltipId={'companyDetail_actionReset'} translationsKey={'tooltip__admin__global__reset'} position="left">
								<PageWrapperActionReset onClick={() => handleResetForm()} />
							</Tooltip>
						</PageWrapperActions>
					</LineTableHeader>
					<PageWrapperGridsCustom>
						<CompanyDetailPart>
							<PageTitle>{translations['page__companiesManagement__detail__companySheet_title']}</PageTitle>
							<CompanyDetailOverflow>
								<CompanyManagerSubPartToggle>
									<LabelTextCustom>
										{translations['page__companiesManagement__detail__companySheet_form_active']}* :
									</LabelTextCustom>
									<Controller
										control={control}
										name="isDisabled"
										as={ToggleFilters}
										checked={stateCompany}
										onChangeHandler={() => {
											handleStateCompany(!stateCompany)
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
										size="large"
										reverseCheck
									/>
								</CompanyManagerSubPartToggle>
								<CompanyManagerSubPartSeparator />
								<CompanyManagerSubPart>
									<LabelTextCustom>
										{translations['page__companiesManagement__detail__companySheet_form_partnerSubGroups']} :
									</LabelTextCustom>
									<DropdownCheckboxHandler>
										<DropdownCheckbox
											title={translations['page__companiesManagement__detail__companySheet_form_placeholder_subGroups']}
											data={hierarchicalSubGroupsPartnershipList || []}
											paperTopPosition={'40'}
											selectActionsHandler={handleHierarchicalSubGroupsPartnershipList}
											submitOnClose={() => null}
											target={'hierarchicalSubGroupsAvailableWithExport'}
										/>
										<div>
											{map(hierarchicalSubGroupsPartnershipList, (partner) => {
												return partner.active ? (
													<PartnerItem>
														<Tooltip
															tooltipId={'companyDetail_actionResetHierarSubPartner'}
															translationsKey={'tooltip__admin__global__deletedChooice'}
															position="left"
														>
															<SearchResetCustom
																onClick={() => {
																	handleDeleted(
																		'hierarchicalSubGroupsAvailableWithExport',
																		partner.id,
																		true,
																		partner
																	)
																}}
															/>
														</Tooltip>
														<LabelTextCustom>{partner.label}</LabelTextCustom>
													</PartnerItem>
												) : null
											})}
										</div>
									</DropdownCheckboxHandler>
								</CompanyManagerSubPart>
								{!isUndefined(find(hierarchicalSubGroupsPartnershipList, (o) => o.active)) && (
									<CompanyManagerSubPart>
										<LabelTextCustom>
											{translations['page__companiesManagement__detail__companySheet_form_extractionInclusion']} :
										</LabelTextCustom>
										<ExportTypeItemWrapper>
											{map(hierarchicalSubGroupsPartnershipExportList, (partnerExport) => {
												return (
													<ExportTypeItem>
														<input
															type="checkbox"
															onClick={() => {
																handleSubGroupExtract(partnerExport.id)
															}}
															checked={partnerExport.active}
														/>
														<LabelTextCustom>{partnerExport.exportLabel}</LabelTextCustom>
													</ExportTypeItem>
												)
											})}
										</ExportTypeItemWrapper>
									</CompanyManagerSubPart>
								)}
								<CompanyManagerSubPart>
									{/* Note : "companyLabel" trad keys doesn't contain the right value, so they are inverted */}
									<LabelTextCustom>
										{translations['page__companiesManagement__detail__companySheet_form_company']}* :
									</LabelTextCustom>
									<InputWrapper>
										<InputLogin
											name="companyLabelCommercial"
											type="text"
											placeholder={translations['common__text__prefilled_informField']}
											ref={register({
												maxLength: {
													value: 150,
													message: `50 ${translations['common__text__charMax']}`,
												},
												minLength: {
													value: 1,
													message: `1 ${translations['common__text__charMin']}`,
												},
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
										/>
										{errors.companyLabelCommercial && <ErrorInputMsg>{errors.companyLabelCommercial.message}</ErrorInputMsg>}
									</InputWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<LabelTextCustom>
										{translations['page__companiesManagement__detail__companySheet_form_labelCommercial']} :
									</LabelTextCustom>
									<InputWrapper>
										<InputLogin
											name="companyLabelToDisplay"
											type="text"
											placeholder={translations['common__text__prefilled_informField']}
											ref={register({
												maxLength: {
													value: 150,
													message: `50 ${translations['common__text__charMax']}`,
												},
												minLength: {
													value: 1,
													message: `1 ${translations['common__text__charMin']}`,
												},
											})}
										/>
										{errors.companyLabelToDisplay && <ErrorInputMsg>{errors.companyLabelToDisplay.message}</ErrorInputMsg>}
									</InputWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<TooltipHelp
										childrenPos={1}
										insideModal={true}
										content={'tooltip__admin__companiesManagement__detail__companySheet_form_smsExpeditor'}
									>
										<LabelTextCustom>
											{translations['page__companiesManagement__detail__companySheet_form_smsExpeditor']} :
										</LabelTextCustom>
									</TooltipHelp>
									<InputWrapper>
										<InputLogin
											name="companyLabelToDisplaySMS"
											type="text"
											placeholder={translations['common__text__prefilled_informField']}
											ref={register({
												maxLength: {
													value: 11,
													message: `11 ${translations['common__text__charMax']}`,
												},
												pattern: {
													value: RegExp(/^[a-zA-Z0-9-_]+$/),
													message:
														translations[
															'page__companiesManagement__detail__companySheet_form_smsExpeditor_invalidChars'
														],
												},
											})}
										/>
										{errors.companyLabelToDisplaySMS && <ErrorInputMsg>{errors.companyLabelToDisplaySMS.message}</ErrorInputMsg>}
									</InputWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<LabelTextCustom>
										{translations['page__companiesManagement__detail__companySheet_form_unlimitedSmsOption']} :
									</LabelTextCustom>
									<ControllerWrapperCustom>
										<Controller
											control={control}
											name="optionSMSIsEnabled"
											as={ToggleFilters}
											checked={isOptionSMSActivated}
											onChangeHandler={() => setIsOptionSMSActivated(!isOptionSMSActivated)}
											rules={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
											labelPrev={translations['common__text__yes']}
											labelNext={translations['common__text__no']}
											size="large"
											reverseCheck
										/>
									</ControllerWrapperCustom>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<LabelTextCustom>
										{translations['page__companiesManagement__detail__divisionSpecificitySheet_freeSmsQty']} :
									</LabelTextCustom>
									<InputLogin
										name={`numberSMSTrial`}
										type="text"
										defaultValue="7"
										ref={register({
											pattern: {
												value: RegExp(/^[0-9]+$/),
												message:
													translations['page__companiesManagement__detail__companySheet_form_smsExpeditor_invalidChars'],
											},
											maxLength: {
												value: 3,
												message: `3 ${translations['common__text__charMax']}`,
											},
											minLength: {
												value: 1,
												message: `1 ${translations['common__text__charMin']}`,
											},
											validate: (value) =>
												(!isOptionSMSActivated && isNumber(parseInt(value)) && value.length > 0) ||
												isOptionSMSActivated ||
												translations['common__text__requiredField'],
										})}
										disabled={isOptionSMSActivated}
										readOnly={isUpdate}
									/>
									{errors.numberSMSTrial && <ErrorInputMsg>{errors.numberSMSTrial.message}</ErrorInputMsg>}
								</CompanyManagerSubPart>
								{isUpdate && (
									<CompanyManagerSubPart>
										<LabelTextCustom>
											{translations['page__companiesManagement__detail__companySheet_form_smSConsumed']} :
										</LabelTextCustom>
										<InputLogin name="quantitySmsConsumed" type="text" ref={register({})} disabled={isUpdate} />
									</CompanyManagerSubPart>
								)}
								{!isOptionSMSActivated && isUpdate && (
									<SMSRefillLink onClick={() => setShowModalSMSRefill(true)}>
										{translations['page__companiesManagement__detail__companySheet_form_requestSmsRecharge']}
									</SMSRefillLink>
								)}
								<CompanyManagerSubPartSeparator />
								<CompanyManagerSubPart>
									<LabelTextCustom>
										{translations['page__companiesManagement__detail__companySheet_form_adress1']}* :
									</LabelTextCustom>
									<InputWrapper>
										<InputLogin
											name="adresse1"
											type="text"
											placeholder={translations['common__text__prefilled_informField']}
											ref={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
												maxLength: {
													value: 150,
													message: `50 ${translations['common__text__charMax']}`,
												},
												minLength: {
													value: 1,
													message: `1 ${translations['common__text__charMin']}`,
												},
											})}
										/>
										{errors.adresse1 && <ErrorInputMsg>{errors.adresse1.message}</ErrorInputMsg>}
									</InputWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<LabelTextCustom>
										{translations['page__companiesManagement__detail__companySheet_form_adress2']} :
									</LabelTextCustom>
									<InputWrapper>
										<InputLogin
											name="adresse2"
											type="text"
											placeholder={translations['common__text__prefilled_informField']}
											ref={register({
												maxLength: {
													value: 150,
													message: `50 ${translations['common__text__charMax']}`,
												},
												minLength: {
													value: 1,
													message: `1 ${translations['common__text__charMin']}`,
												},
											})}
										/>
										{errors.adresse2 && <ErrorInputMsg>{errors.adresse2.message}</ErrorInputMsg>}
									</InputWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<LabelTextCustom>
										{translations['page__companiesManagement__detail__companySheet_form_adress3']} :
									</LabelTextCustom>
									<InputWrapper>
										<InputLogin
											name="adresse3"
											type="text"
											placeholder={translations['common__text__prefilled_informField']}
											ref={register({
												maxLength: {
													value: 150,
													message: `50 ${translations['common__text__charMax']}`,
												},
												minLength: {
													value: 1,
													message: `1 ${translations['common__text__charMin']}`,
												},
											})}
										/>
										{errors.adresse3 && <ErrorInputMsg>{errors.adresse3.message}</ErrorInputMsg>}
									</InputWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<LabelTextCustom>
										{translations['page__companiesManagement__detail__companySheet_form_adress4']} :
									</LabelTextCustom>
									<InputWrapper>
										<InputLogin
											name="adresse4"
											type="text"
											placeholder={translations['common__text__prefilled_informField']}
											ref={register({
												maxLength: {
													value: 150,
													message: `50 ${translations['common__text__charMax']}`,
												},
												minLength: {
													value: 1,
													message: `1 ${translations['common__text__charMin']}`,
												},
											})}
										/>
										{errors.adresse4 && <ErrorInputMsg>{errors.adresse4.message}</ErrorInputMsg>}
									</InputWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<LabelTextCustom>
										{translations['page__companiesManagement__detail__companySheet_form_postalCode']}* :
									</LabelTextCustom>
									<InputWrapper>
										<InputLogin
											name="postalCode"
											type="text"
											placeholder={translations['common__text__prefilled_informField']}
											ref={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
												maxLength: {
													value: 15,
													message: `15 ${translations['common__text__charMax']}`,
												},
												minLength: {
													value: 1,
													message: `1 ${translations['common__text__charMin']}`,
												},
											})}
										/>
										{errors.postalCode && <ErrorInputMsg>{errors.postalCode.message}</ErrorInputMsg>}
									</InputWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<LabelTextCustom>{translations['page__companiesManagement__detail__companySheet_form_city']}* :</LabelTextCustom>
									<InputWrapper>
										<InputLogin
											name="city"
											type="text"
											placeholder={translations['common__text__prefilled_informField']}
											ref={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
												maxLength: {
													value: 150,
													message: `150 ${translations['common__text__charMax']}`,
												},
												minLength: {
													value: 1,
													message: `1 ${translations['common__text__charMin']}`,
												},
											})}
										/>
										{errors.city && <ErrorInputMsg>{errors.city.message}</ErrorInputMsg>}
									</InputWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<TooltipHelp
										childrenPos={1}
										insideModal={true}
										content={'tooltip__admin__companiesManagement__detail__companySheet_form_country'}
									>
										<LabelTextCustom>
											{translations['page__companiesManagement__detail__companySheet_form_country']}* :
										</LabelTextCustom>
									</TooltipHelp>
									<div>
										<SelectInputWrapper>
											<SelectInputCustom
												width="212"
												name="idCountry"
												ref={register({
													required: {
														value: true,
														message: translations['common__text__requiredField'],
													},
													validate: (value) => value > 0 || translations['common__text__requiredField'],
												})}
												onChange={(e) => setCountrySelected(find(countriesList, { id: parseInt(e.target.value) }))}
												disabled={isUpdate}
												className={watch('idCountry') > 0 ? 'active' : ''}
												defaultValues=""
											>
												<OptionCustom value="0" hidden>
													{translations['common__text__prefilled_choiceCountry']}
												</OptionCustom>
												{map(companyDetail.availableOptions.countriesAvailable, (elem, id) => {
													return (
														<OptionCustom
															key={id}
															value={elem.id}
															selected={
																props.kioskCreationMode &&
																props.dataPassed &&
																!isEqual(kioskCreationDefinitionData, {}) &&
																kioskCreationDefinitionData.userCreatedStoreInfo.country === elem.countryName
															}
															target={true}
														>
															{elem.countryName}
														</OptionCustom>
													)
												})}
											</SelectInputCustom>
										</SelectInputWrapper>
										{errors.idCountry && <ErrorInputMsg>{errors.idCountry.message}</ErrorInputMsg>}
									</div>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<LabelTextCustom>
										{translations['page__companiesManagement__detail__companySheet_form_phoneCompany']} :
									</LabelTextCustom>
									<InputWrapper>
										<InputLogin
											name="phoneCompany"
											type="text"
											placeholder={translations['common__text__prefilled_informField']}
											ref={register({})}
										/>
										{errors.phoneCompany && <ErrorInputMsg>{errors.phoneCompany.message}</ErrorInputMsg>}
									</InputWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<LabelTextCustom>
										{translations['page__companiesManagement__detail__companySheet_form_emailCompany']} :
									</LabelTextCustom>
									<InputWrapper>
										<InputLogin
											type="text"
											name="emailCompany"
											placeholder={translations['common__text__prefilled_informField']}
											ref={register({
												maxLength: {
													value: 150,
													message: `150 ${translations['common__text__charMax']}`,
												},
												pattern: {
													value: RegExp(
														/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
													),
													message: translations['common__text__invalidEmail'],
												},
											})}
										/>
										{errors.emailCompany && <ErrorInputMsg>{errors.emailCompany.message}</ErrorInputMsg>}
									</InputWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<LabelTextCustom>
										{translations['page__companiesManagement__detail__companySheet_openingHours']} :
									</LabelTextCustom>
									<InputWrapper>
										<InputLogin
											name="openingHours"
											type="text"
											placeholder={translations['page__companiesManagement__detail__companySheet_openingHours_placeholder']}
											ref={register({
												maxLength: {
													value: 150,
													message: `50 ${translations['common__text__charMax']}`,
												},
												minLength: {
													value: 1,
													message: `1 ${translations['common__text__charMin']}`,
												},
											})}
										/>
										{errors.openingHours && <ErrorInputMsg>{errors.openingHours.message}</ErrorInputMsg>}
									</InputWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<LabelTextCustom>{translations['page__companiesManagement__detail__companySheet_form_siret']} :</LabelTextCustom>
									<InputWrapper>
										<InputLogin
											name="siret"
											type="text"
											placeholder={translations['common__text__prefilled_informField']}
											ref={register({
												maxLength: {
													value: 150,
													message: `50 ${translations['common__text__charMax']}`,
												},
											})}
										/>
										{errors.siret && <ErrorInputMsg>{errors.siret.message}</ErrorInputMsg>}
									</InputWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<LabelTextCustom>
										{translations['page__companiesManagement__detail__companySheet_form_contact']} :
									</LabelTextCustom>
									<InputWrapper>
										<InputLogin
											name="contactName"
											type="text"
											placeholder={translations['common__text__prefilled_informField']}
											ref={register({
												maxLength: {
													value: 150,
													message: `150 ${translations['common__text__charMax']}`,
												},
												minLength: {
													value: 1,
													message: `1 ${translations['common__text__charMin']}`,
												},
											})}
										/>
										{errors.contactName && <ErrorInputMsg>{errors.contactName.message}</ErrorInputMsg>}
									</InputWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<LabelTextCustom>
										{translations['page__companiesManagement__detail__companySheet_form_emailContact']}* :
									</LabelTextCustom>
									<InputWrapper>
										<InputLogin
											name="contactEmail"
											type="text"
											placeholder={translations['common__text__prefilled_informField']}
											ref={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
												maxLength: {
													value: 150,
													message: `150 ${translations['common__text__charMax']}`,
												},
												minLength: {
													value: 1,
													message: `1 ${translations['common__text__charMin']}`,
												},
												pattern: {
													value: RegExp(
														/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
													),
													message: translations['common__text__invalidEmail'],
												},
											})}
										/>
										{errors.contactEmail && <ErrorInputMsg>{errors.contactEmail.message}</ErrorInputMsg>}
									</InputWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<LabelTextCustom>
										{translations['page__companiesManagement__detail__companySheet_form_phoneContact']} :
									</LabelTextCustom>
									<InputWrapper>
										<InputLogin
											name="contactPhone"
											type="text"
											placeholder={translations['common__text__prefilled_informField']}
											ref={register({})}
										/>
										{errors.contactPhone && <ErrorInputMsg>{errors.contactPhone.message}</ErrorInputMsg>}
									</InputWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<TooltipHelp
										childrenPos={1}
										insideModal={true}
										content={'page__companiesManagement__detail__companySheet_itemPicture_propertie'}
									>
										<LabelTextCustom>
											{translations['page__companiesManagement__detail__companySheet_form_picture']} :
										</LabelTextCustom>
									</TooltipHelp>
									<SelectInputWrapper>
										<SelectInputCustom
											width="212"
											name="pictureNameSelected"
											ref={register({})}
											onChange={(e) => handleLogoNameSelected(e.target.value)}
											className={watch('pictureNameSelected') !== '' ? 'active' : ''}
											defaultValues=""
										>
											<OptionCustom value="" hidden>
												{translations['page__companiesManagement__detail__companySheet_form_placeholder_selectPicture']}
											</OptionCustom>
											{map(sortedLogoNames, (elem, id) => {
												const logoName = elem.logoName.split('.')[0]
												return (
													<OptionCustom
														key={id}
														value={elem.logoName}
														selected={logoNameSelected?.logoName === elem.logoName}
														target={true}
													>
														{logoName}
													</OptionCustom>
												)
											})}
										</SelectInputCustom>
									</SelectInputWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart>
									<div></div>
									<ControllerFileWrapper>
										<input
											type="file"
											id="pictureBase64"
											name="pictureBase64"
											multiple="false"
											onChange={(e) => handleFileReading(e.target.files[0])}
											accept=".img,.png"
										/>
										<LabelFileCustom for="pictureBase64" width="212">
											{translations['common__text__prefilled_informField']}
										</LabelFileCustom>
										<span>{translations['page__companiesManagement__detail__companySheet_form_logo']}</span>
									</ControllerFileWrapper>
								</CompanyManagerSubPart>
								<CompanyManagerSubPart class="va-top">
									<div></div>
									<PreviewFileHandler>
										{errorsPictureBase64Msg.length > 0 && <ErrorInputMsg>{errorsPictureBase64Msg}</ErrorInputMsg>}
										{errors.pictureBase64 && <ErrorInputMsg>{errors.pictureBase64.message}</ErrorInputMsg>}
										{previewBase64.length > 0 && (
											<PreviewFileWrapper>
												<img src={previewBase64} />
											</PreviewFileWrapper>
										)}
										{previewBase64.length > 0 && (
											<Tooltip
												tooltipId={`companyDetail_actionResetLogo`}
												translationsKey={'tooltip__admin__global__deletedChooice'}
											>
												<SearchResetCustom
													onClick={() => {
														handleDeletePicture()
													}}
												/>
											</Tooltip>
										)}
									</PreviewFileHandler>
								</CompanyManagerSubPart>
							</CompanyDetailOverflow>
						</CompanyDetailPart>
						<CompanyDetailPart>
							<TooltipHelp
								childrenPos={1}
								insideModal={true}
								content={'tooltip__admin__companiesManagement__detail__divisionSheet_title'}
							>
								<PageTitle>{translations['page__companiesManagement__detail__divisionSheet_title']}</PageTitle>
							</TooltipHelp>
							<CompanyDivisions visible={divisionsSelected.length > 0}>
								<CompanyDivisionPart>
									{!isEmpty(divisionsList) &&
										map(divisions_config, (elem) => {
											// If the property exist in divisionsList
											const obj = get(divisionsList, elem.type)
											const pic = find(divisionPicsConfig, { id: elem.id })
											if (!isUndefined(obj)) {
												return (
													<CompanyDiv selected={find(divisionsSelected, (o) => o === elem.id) ? true : false}>
														<input
															type="checkbox"
															value={elem.id}
															defaultChecked={obj.isSelected}
															checked={
																(isUpdate && obj.isSelected) ||
																(elem.type === 'store' && props.kioskCreationMode && !props.noDataPassed)
																	? true
																	: null
															}
															onClick={() => {
																handleDivisionsSelected(elem.id, obj)
															}}
														/>
														<img src={`${!isUndefined(pic) && pic.picture}`} />
														<span>{translations[obj.translationKey]}</span>
													</CompanyDiv>
												)
											}
										})}
								</CompanyDivisionPart>
								<CompanyDivisionFields visible={divisionsSelected.length > 0}>{divisionsRender}</CompanyDivisionFields>
							</CompanyDivisions>
						</CompanyDetailPart>
					</PageWrapperGridsCustom>
				</form>
			</CompanyDetailWrapper>
		</Fragment>
	)
}

CompanyDetail.propTypes = {}

CompanyDetail.defaultPropTypes = {}

export default CompanyDetail
